// Generated by `pnpm --filter schemas gen:workflow-fixtures` from packages/schemas/workflow-fixtures. Do not edit.
import type { Workflow } from "../workflows";

/** Every built-in workflow, in WORKFLOW_SLUGS order. */
export const WORKFLOW_FIXTURES: Workflow[] = [
  {
    "slug": "build-landing-page",
    "art": {
      "scene": "page",
      "page": "landing"
    },
    "requires": [
      "checkout/replo"
    ],
    "vertical": "ecommerce",
    "tab": "scale",
    "order": 0,
    "kind": "setup",
    "rewardKey": "home-page",
    "completion": "all",
    "title": "Build an ecommerce landing page",
    "description": "Turn campaign clicks into sales with a page built around your offer.",
    "steps": [
      {
        "slug": "import-brand",
        "title": "Set up Branding",
        "check": "brand-business",
        "body": "brand",
        "options": []
      },
      {
        "slug": "choose-product",
        "title": "Choose a product",
        "check": null,
        "body": "product",
        "options": [],
        "productSource": "replo"
      },
      {
        "slug": "build-campaign-page",
        "title": "Build your page",
        "check": null,
        "output": "page",
        "body": "page",
        "pageType": "template",
        "options": []
      },
      {
        "slug": "publish-your-site",
        "title": "Publish your site",
        "check": null,
        "body": "publish",
        "options": []
      }
    ]
  },
  {
    "slug": "shopify-build-landing-page",
    "art": {
      "scene": "page",
      "page": "landing"
    },
    "requires": [
      "checkout/shopify"
    ],
    "vertical": "ecommerce",
    "tab": "scale",
    "order": 0,
    "kind": "setup",
    "rewardKey": "home-page",
    "completion": "all",
    "title": "Build a Shopify landing page",
    "description": "Turn campaign clicks into sales with a page built around your offer.",
    "steps": [
      {
        "slug": "connect-shopify",
        "title": "Connect your Shopify store",
        "description": "Use your store’s products, prices, and photos in your campaign pages.",
        "check": "has-connected-shopify",
        "body": "shopify",
        "options": []
      },
      {
        "slug": "import-brand",
        "title": "Set up Branding",
        "check": "brand-business",
        "body": "brand",
        "options": []
      },
      {
        "slug": "choose-product",
        "title": "Choose a product",
        "check": null,
        "body": "product",
        "options": []
      },
      {
        "slug": "build-campaign-page",
        "title": "Build your page",
        "check": null,
        "output": "page",
        "body": "page",
        "pageType": "template",
        "options": []
      },
      {
        "slug": "publish-your-site",
        "title": "Publish your site",
        "check": null,
        "body": "publish",
        "options": []
      }
    ],
    "baseWorkflow": "build-landing-page"
  },
  {
    "slug": "build-product-page",
    "art": {
      "scene": "page",
      "page": "product"
    },
    "hidden": false,
    "retired": false,
    "requires": [
      "checkout/replo"
    ],
    "vertical": "ecommerce",
    "tab": "launch",
    "order": 1,
    "kind": "explore",
    "rewardKey": "home-build-shopify-product-page",
    "completion": "all",
    "title": "Build a product page",
    "description": "Turn product interest into purchases with proof and a clear offer.",
    "steps": [
      {
        "slug": "import-brand",
        "title": "Set up Branding",
        "check": "brand-business",
        "body": "brand",
        "options": []
      },
      {
        "slug": "choose-product",
        "title": "Choose a product",
        "check": null,
        "body": "product",
        "options": [],
        "productSource": "replo"
      },
      {
        "slug": "build-page",
        "title": "Build your page",
        "check": null,
        "body": "page",
        "output": "page",
        "pageType": "product",
        "options": []
      },
      {
        "slug": "publish-page",
        "title": "Publish your site",
        "check": null,
        "body": "publish",
        "options": []
      }
    ]
  },
  {
    "slug": "shopify-build-product-page",
    "art": {
      "scene": "page",
      "page": "product"
    },
    "hidden": false,
    "retired": false,
    "requires": [
      "checkout/shopify"
    ],
    "vertical": "ecommerce",
    "tab": "launch",
    "order": 1,
    "kind": "explore",
    "rewardKey": "home-build-shopify-product-page",
    "completion": "all",
    "title": "Build a Shopify product page",
    "description": "Turn product interest into purchases with proof and a clear offer.",
    "steps": [
      {
        "slug": "connect-shopify",
        "title": "Connect your Shopify store",
        "description": "Use your catalog, or skip for now and build with placeholder products.",
        "check": "has-connected-shopify",
        "body": "shopify",
        "options": []
      },
      {
        "slug": "import-brand",
        "title": "Set up Branding",
        "check": "brand-business",
        "body": "brand",
        "options": []
      },
      {
        "slug": "choose-product",
        "title": "Choose a product",
        "check": null,
        "body": "product",
        "options": []
      },
      {
        "slug": "build-page",
        "title": "Build your page",
        "check": null,
        "body": "page",
        "output": "page",
        "pageType": "product",
        "options": []
      },
      {
        "slug": "publish-page",
        "title": "Publish your site",
        "check": null,
        "body": "publish",
        "options": []
      }
    ],
    "baseWorkflow": "build-product-page"
  },
  {
    "slug": "build-listicle",
    "art": {
      "scene": "page",
      "page": "listicle"
    },
    "hidden": false,
    "retired": false,
    "requires": [
      "checkout/replo"
    ],
    "vertical": "ecommerce",
    "tab": "scale",
    "order": 2,
    "kind": "explore",
    "rewardKey": "home-build-shopify-listicle",
    "completion": "all",
    "title": "Build a listicle",
    "description": "Give new shoppers compelling reasons to choose your product.",
    "steps": [
      {
        "slug": "import-brand",
        "title": "Set up Branding",
        "check": "brand-business",
        "body": "brand",
        "options": []
      },
      {
        "slug": "choose-product",
        "title": "Choose a product",
        "check": null,
        "body": "product",
        "options": [],
        "productSource": "replo"
      },
      {
        "slug": "build-page",
        "title": "Build your page",
        "check": null,
        "body": "page",
        "output": "page",
        "pageType": "listicle",
        "options": []
      },
      {
        "slug": "publish-page",
        "title": "Publish your site",
        "check": null,
        "body": "publish",
        "options": []
      }
    ]
  },
  {
    "slug": "shopify-build-listicle",
    "art": {
      "scene": "page",
      "page": "listicle"
    },
    "hidden": false,
    "retired": false,
    "requires": [
      "checkout/shopify"
    ],
    "vertical": "ecommerce",
    "tab": "scale",
    "order": 2,
    "kind": "explore",
    "rewardKey": "home-build-shopify-listicle",
    "completion": "all",
    "title": "Build a Shopify listicle",
    "description": "Give new shoppers compelling reasons to choose your product.",
    "steps": [
      {
        "slug": "connect-shopify",
        "title": "Connect your Shopify store",
        "description": "Use your catalog, or skip for now and build with placeholder products.",
        "check": "has-connected-shopify",
        "body": "shopify",
        "options": []
      },
      {
        "slug": "import-brand",
        "title": "Set up Branding",
        "check": "brand-business",
        "body": "brand",
        "options": []
      },
      {
        "slug": "choose-product",
        "title": "Choose a product",
        "check": null,
        "body": "product",
        "options": []
      },
      {
        "slug": "build-page",
        "title": "Build your page",
        "check": null,
        "body": "page",
        "output": "page",
        "pageType": "listicle",
        "options": []
      },
      {
        "slug": "publish-page",
        "title": "Publish your site",
        "check": null,
        "body": "publish",
        "options": []
      }
    ],
    "baseWorkflow": "build-listicle"
  },
  {
    "slug": "build-advertorial",
    "art": {
      "scene": "page",
      "page": "advertorial"
    },
    "hidden": false,
    "retired": false,
    "requires": [
      "checkout/replo"
    ],
    "vertical": "ecommerce",
    "tab": "scale",
    "order": 3,
    "kind": "explore",
    "rewardKey": "home-build-shopify-advertorial",
    "completion": "all",
    "title": "Build an advertorial",
    "description": "Connect a customer problem to your product through an editorial story.",
    "steps": [
      {
        "slug": "import-brand",
        "title": "Set up Branding",
        "check": "brand-business",
        "body": "brand",
        "options": []
      },
      {
        "slug": "choose-product",
        "title": "Choose a product",
        "check": null,
        "body": "product",
        "options": [],
        "productSource": "replo"
      },
      {
        "slug": "build-page",
        "title": "Build your page",
        "check": null,
        "body": "page",
        "output": "page",
        "pageType": "advertorial",
        "options": []
      },
      {
        "slug": "publish-page",
        "title": "Publish your site",
        "check": null,
        "body": "publish",
        "options": []
      }
    ]
  },
  {
    "slug": "shopify-build-advertorial",
    "art": {
      "scene": "page",
      "page": "advertorial"
    },
    "hidden": false,
    "retired": false,
    "requires": [
      "checkout/shopify"
    ],
    "vertical": "ecommerce",
    "tab": "scale",
    "order": 3,
    "kind": "explore",
    "rewardKey": "home-build-shopify-advertorial",
    "completion": "all",
    "title": "Build a Shopify advertorial",
    "description": "Connect a customer problem to your product through an editorial story.",
    "steps": [
      {
        "slug": "connect-shopify",
        "title": "Connect your Shopify store",
        "description": "Use your catalog, or skip for now and build with placeholder products.",
        "check": "has-connected-shopify",
        "body": "shopify",
        "options": []
      },
      {
        "slug": "import-brand",
        "title": "Set up Branding",
        "check": "brand-business",
        "body": "brand",
        "options": []
      },
      {
        "slug": "choose-product",
        "title": "Choose a product",
        "check": null,
        "body": "product",
        "options": []
      },
      {
        "slug": "build-page",
        "title": "Build your page",
        "check": null,
        "body": "page",
        "output": "page",
        "pageType": "advertorial",
        "options": []
      },
      {
        "slug": "publish-page",
        "title": "Publish your site",
        "check": null,
        "body": "publish",
        "options": []
      }
    ],
    "baseWorkflow": "build-advertorial"
  },
  {
    "slug": "build-bundle",
    "art": {
      "scene": "page",
      "page": "bundle"
    },
    "hidden": false,
    "retired": false,
    "requires": [
      "checkout/replo"
    ],
    "vertical": "ecommerce",
    "tab": "scale",
    "order": 4,
    "kind": "explore",
    "rewardKey": "home-build-shopify-bundle",
    "completion": "all",
    "title": "Build a bundle builder",
    "description": "Grow order value with bundles customers can mix and match.",
    "steps": [
      {
        "slug": "import-brand",
        "title": "Set up Branding",
        "check": "brand-business",
        "body": "brand",
        "options": []
      },
      {
        "slug": "choose-products",
        "title": "Choose products for your bundle",
        "check": null,
        "body": "product",
        "options": [],
        "description": "Select at least 2 products. Confirm quantities and discount rules when building.",
        "productSelection": "multiple",
        "productSource": "replo"
      },
      {
        "slug": "build-page",
        "title": "Build your page",
        "check": null,
        "body": "page",
        "output": "page",
        "pageType": "bundle",
        "options": []
      },
      {
        "slug": "publish-page",
        "title": "Publish your site",
        "check": null,
        "body": "publish",
        "options": []
      }
    ]
  },
  {
    "slug": "shopify-build-bundle",
    "art": {
      "scene": "page",
      "page": "bundle"
    },
    "hidden": false,
    "retired": false,
    "requires": [
      "checkout/shopify"
    ],
    "vertical": "ecommerce",
    "tab": "scale",
    "order": 4,
    "kind": "explore",
    "rewardKey": "home-build-shopify-bundle",
    "completion": "all",
    "title": "Build a Shopify bundle builder",
    "description": "Grow order value with bundles customers can mix and match.",
    "steps": [
      {
        "slug": "connect-shopify",
        "title": "Connect your Shopify store",
        "description": "Use your catalog, or skip for now and build with placeholder products.",
        "check": "has-connected-shopify",
        "body": "shopify",
        "options": []
      },
      {
        "slug": "import-brand",
        "title": "Set up Branding",
        "check": "brand-business",
        "body": "brand",
        "options": []
      },
      {
        "slug": "choose-products",
        "title": "Choose products for your bundle",
        "check": null,
        "body": "product",
        "options": [],
        "description": "Select at least 2 products. Confirm quantities and discount rules when building.",
        "productSelection": "multiple"
      },
      {
        "slug": "build-page",
        "title": "Build your page",
        "check": null,
        "body": "page",
        "output": "page",
        "pageType": "bundle",
        "options": []
      },
      {
        "slug": "publish-page",
        "title": "Publish your site",
        "check": null,
        "body": "publish",
        "options": []
      }
    ],
    "baseWorkflow": "build-bundle"
  },
  {
    "slug": "copy-page",
    "art": {
      "scene": "page",
      "page": "copy"
    },
    "hidden": false,
    "retired": false,
    "requires": [
      "checkout/replo"
    ],
    "vertical": "ecommerce",
    "tab": "scale",
    "order": 5,
    "kind": "explore",
    "rewardKey": "home-copy-shopify-page",
    "completion": "all",
    "title": "Copy an existing ecommerce landing page",
    "description": "Rebuild a landing page you already like with your brand and products.",
    "steps": [
      {
        "slug": "import-brand",
        "title": "Set up Branding",
        "check": "brand-business",
        "body": "brand",
        "options": []
      },
      {
        "slug": "choose-product",
        "title": "Choose a product",
        "check": null,
        "body": "product",
        "options": [],
        "productSource": "replo"
      },
      {
        "slug": "build-page",
        "title": "Copy a page from a URL",
        "check": null,
        "body": "page",
        "output": "page",
        "pageType": "url",
        "options": []
      },
      {
        "slug": "publish-page",
        "title": "Publish your site",
        "check": null,
        "body": "publish",
        "options": []
      }
    ]
  },
  {
    "slug": "shopify-copy-page",
    "art": {
      "scene": "page",
      "page": "copy"
    },
    "hidden": false,
    "retired": false,
    "requires": [
      "checkout/shopify"
    ],
    "vertical": "ecommerce",
    "tab": "scale",
    "order": 5,
    "kind": "explore",
    "rewardKey": "home-copy-shopify-page",
    "completion": "all",
    "title": "Copy an existing landing page",
    "description": "Rebuild a landing page you already like with your brand and products.",
    "steps": [
      {
        "slug": "connect-shopify",
        "title": "Connect your Shopify store",
        "description": "Use your catalog, or skip for now and build with placeholder products.",
        "check": "has-connected-shopify",
        "body": "shopify",
        "options": []
      },
      {
        "slug": "import-brand",
        "title": "Set up Branding",
        "check": "brand-business",
        "body": "brand",
        "options": []
      },
      {
        "slug": "choose-product",
        "title": "Choose a product",
        "check": null,
        "body": "product",
        "options": []
      },
      {
        "slug": "build-page",
        "title": "Copy a page from a URL",
        "check": null,
        "body": "page",
        "output": "page",
        "pageType": "url",
        "options": []
      },
      {
        "slug": "publish-page",
        "title": "Publish your site",
        "check": null,
        "body": "publish",
        "options": []
      }
    ],
    "baseWorkflow": "copy-page"
  },
  {
    "slug": "copy-competitor-page",
    "art": {
      "scene": "page",
      "page": "competitor"
    },
    "hidden": false,
    "retired": false,
    "requires": [
      "checkout/replo"
    ],
    "vertical": "ecommerce",
    "tab": "scale",
    "order": 6,
    "kind": "explore",
    "rewardKey": "home-copy-competitor-page",
    "completion": "all",
    "title": "Copy a competitor's ecommerce page",
    "description": "Borrow the structure of a page that works for a competitor, told in your own words.",
    "steps": [
      {
        "slug": "import-brand",
        "title": "Set up Branding",
        "check": "brand-business",
        "body": "brand",
        "options": []
      },
      {
        "slug": "choose-product",
        "title": "Choose a product",
        "check": null,
        "body": "product",
        "options": [],
        "productSource": "replo"
      },
      {
        "slug": "build-page",
        "title": "Choose a competitor's page",
        "check": null,
        "body": "page",
        "output": "page",
        "pageType": "competitor",
        "options": []
      },
      {
        "slug": "publish-page",
        "title": "Publish your site",
        "check": null,
        "body": "publish",
        "options": []
      }
    ]
  },
  {
    "slug": "shopify-copy-competitor-page",
    "art": {
      "scene": "page",
      "page": "competitor"
    },
    "hidden": false,
    "retired": false,
    "requires": [
      "checkout/shopify"
    ],
    "vertical": "ecommerce",
    "tab": "scale",
    "order": 6,
    "kind": "explore",
    "rewardKey": "home-copy-competitor-page",
    "completion": "all",
    "title": "Copy a competitor's page",
    "description": "Borrow the structure of a page that works for a competitor, told in your own words.",
    "steps": [
      {
        "slug": "connect-shopify",
        "title": "Connect your Shopify store",
        "description": "Use your catalog, or skip for now and build with placeholder products.",
        "check": "has-connected-shopify",
        "body": "shopify",
        "options": []
      },
      {
        "slug": "import-brand",
        "title": "Set up Branding",
        "check": "brand-business",
        "body": "brand",
        "options": []
      },
      {
        "slug": "choose-product",
        "title": "Choose a product",
        "check": null,
        "body": "product",
        "options": []
      },
      {
        "slug": "build-page",
        "title": "Choose a competitor's page",
        "check": null,
        "body": "page",
        "output": "page",
        "pageType": "competitor",
        "options": []
      },
      {
        "slug": "publish-page",
        "title": "Publish your site",
        "check": null,
        "body": "publish",
        "options": []
      }
    ],
    "baseWorkflow": "copy-competitor-page"
  },
  {
    "slug": "import-figma",
    "art": {
      "scene": "page",
      "page": "figma"
    },
    "hidden": false,
    "retired": false,
    "requires": [
      "checkout/replo"
    ],
    "vertical": "ecommerce",
    "tab": "scale",
    "order": 13,
    "kind": "explore",
    "rewardKey": "home-import-shopify-figma",
    "completion": "all",
    "title": "Import a Figma design for ecommerce",
    "description": "Turn your Figma design into an editable page with real product data.",
    "steps": [
      {
        "slug": "import-brand",
        "title": "Set up Branding",
        "check": "brand-business",
        "body": "brand",
        "options": []
      },
      {
        "slug": "choose-product",
        "title": "Choose a product",
        "check": null,
        "body": "product",
        "options": [],
        "productSource": "replo"
      },
      {
        "slug": "build-page",
        "title": "Choose your Figma design",
        "check": null,
        "body": "page",
        "output": "page",
        "pageType": "figma",
        "options": []
      },
      {
        "slug": "publish-page",
        "title": "Publish your site",
        "check": null,
        "body": "publish",
        "options": []
      }
    ]
  },
  {
    "slug": "shopify-import-figma",
    "art": {
      "scene": "page",
      "page": "figma"
    },
    "hidden": false,
    "retired": false,
    "requires": [
      "checkout/shopify"
    ],
    "vertical": "ecommerce",
    "tab": "scale",
    "order": 13,
    "kind": "explore",
    "rewardKey": "home-import-shopify-figma",
    "completion": "all",
    "title": "Import a Figma design for Shopify",
    "description": "Turn your Figma design into an editable page with real product data.",
    "steps": [
      {
        "slug": "connect-shopify",
        "title": "Connect your Shopify store",
        "description": "Use your catalog, or skip for now and build with placeholder products.",
        "check": "has-connected-shopify",
        "body": "shopify",
        "options": []
      },
      {
        "slug": "import-brand",
        "title": "Set up Branding",
        "check": "brand-business",
        "body": "brand",
        "options": []
      },
      {
        "slug": "choose-product",
        "title": "Choose a product",
        "check": null,
        "body": "product",
        "options": []
      },
      {
        "slug": "build-page",
        "title": "Choose your Figma design",
        "check": null,
        "body": "page",
        "output": "page",
        "pageType": "figma",
        "options": []
      },
      {
        "slug": "publish-page",
        "title": "Publish your site",
        "check": null,
        "body": "publish",
        "options": []
      }
    ],
    "baseWorkflow": "import-figma"
  },
  {
    "slug": "start-shopify-template",
    "hidden": true,
    "retired": true,
    "requires": [
      "checkout/shopify"
    ],
    "vertical": "ecommerce",
    "tab": "scale",
    "order": 6,
    "kind": "explore",
    "rewardKey": "home-start-shopify-template",
    "completion": "all",
    "title": "Start from a template",
    "description": "Launch your next offer faster with a layout tailored to your store.",
    "steps": [
      {
        "slug": "connect-shopify",
        "title": "Connect your Shopify store",
        "description": "Use your catalog, or skip for now and build with placeholder products.",
        "check": "has-connected-shopify",
        "body": "shopify",
        "options": []
      },
      {
        "slug": "import-brand",
        "title": "Set up Branding",
        "check": "brand-business",
        "body": "brand",
        "options": []
      },
      {
        "slug": "choose-product",
        "title": "Choose a product",
        "check": null,
        "body": "product",
        "options": []
      },
      {
        "slug": "build-page",
        "title": "Build your page",
        "check": null,
        "body": "page",
        "output": "page",
        "pageType": "template",
        "options": []
      },
      {
        "slug": "publish-page",
        "title": "Publish your site",
        "check": null,
        "body": "publish",
        "options": []
      }
    ]
  },
  {
    "slug": "build-shopify-quiz",
    "hidden": true,
    "retired": true,
    "requires": [
      "checkout/shopify"
    ],
    "vertical": "ecommerce",
    "tab": "scale",
    "order": 8,
    "kind": "explore",
    "rewardKey": "home-build-shopify-quiz",
    "completion": "all",
    "title": "Build a product quiz",
    "description": "Guide shoppers to the right products with personalized recommendations.",
    "comingSoon": false,
    "steps": [
      {
        "slug": "prepare-brief",
        "output": "page",
        "title": "Plan my product quiz",
        "check": null,
        "options": [
          {
            "id": "start",
            "label": "Plan my product quiz",
            "primary": true,
            "prompt": "Build a product recommendation quiz for my Shopify store. Reuse my connected store and brand. Ask which products to recommend and what distinguishes them. Confirm three to five questions and the recommendation rules, then build the quiz, results page, and a path to the real store checkout. Show me the draft and verify each answer path before publishing."
          }
        ]
      },
      {
        "slug": "publish-page",
        "title": "Publish your site",
        "check": null,
        "body": "publish",
        "options": []
      }
    ]
  },
  {
    "slug": "audit-shopify-page",
    "hidden": true,
    "retired": true,
    "requires": [
      "checkout/shopify"
    ],
    "vertical": "ecommerce",
    "tab": "scale",
    "order": 9,
    "kind": "explore",
    "rewardKey": "home-audit-shopify-page",
    "completion": "all",
    "title": "Run a CRO page audit",
    "description": "Find purchase friction and prioritize changes to test on your page.",
    "comingSoon": false,
    "steps": [
      {
        "slug": "prepare-brief",
        "title": "Review my page",
        "check": null,
        "options": [
          {
            "id": "start",
            "label": "Review my page",
            "primary": true,
            "prompt": "Audit a public ecommerce page for conversion opportunities. Ask me for its URL and target audience. Review the offer, messaging, mobile layout, trust, and purchase path. Separate observed problems from hypotheses, cite specific page sections, and prioritize recommended changes. Do not invent analytics or claim a conversion lift. Show me the findings before changing the page."
          }
        ]
      },
      {
        "slug": "review-result",
        "title": "Your results",
        "check": null,
        "body": "deliverable",
        "completionLabel": "Finish workflow",
        "options": []
      }
    ]
  },
  {
    "slug": "shopify-build-persona-page",
    "hidden": true,
    "retired": false,
    "requires": [
      "checkout/shopify"
    ],
    "vertical": "ecommerce",
    "tab": "scale",
    "order": 10,
    "kind": "explore",
    "rewardKey": "home-build-shopify-persona-page",
    "completion": "all",
    "title": "Build a page for a customer persona",
    "description": "Match your page to an audience’s needs, motivations, and objections.",
    "comingSoon": false,
    "steps": [
      {
        "slug": "prepare-brief",
        "output": "page",
        "title": "Choose my audience",
        "check": null,
        "options": [
          {
            "id": "start",
            "label": "Choose my audience",
            "primary": true,
            "prompt": "Adapt a Shopify landing page to a specific customer persona. Ask for the existing page or product and the audience, their needs, and objections. Reuse my brand and real product data. Create a separate draft focused on that audience without changing the original page or inventing reviews. Show me what changed before publishing."
          }
        ]
      },
      {
        "slug": "publish-page",
        "title": "Publish your site",
        "check": null,
        "body": "publish",
        "options": []
      }
    ]
  },
  {
    "slug": "shopify-build-ab-variant",
    "hidden": true,
    "retired": false,
    "requires": [
      "checkout/shopify"
    ],
    "vertical": "ecommerce",
    "tab": "scale",
    "order": 11,
    "kind": "explore",
    "rewardKey": "home-build-shopify-ab-variant",
    "completion": "all",
    "title": "Build an A/B test variant",
    "description": "Test a new message or offer with a focused variant of your page.",
    "comingSoon": false,
    "steps": [
      {
        "slug": "prepare-brief",
        "output": "page",
        "title": "Plan my page variant",
        "check": null,
        "options": [
          {
            "id": "start",
            "label": "Plan my page variant",
            "primary": true,
            "prompt": "Create an A/B test variant of my Shopify landing page. Ask for the page and one hypothesis to test. Preserve the original and create a separate draft, changing only what the hypothesis requires. Explain the change and a success metric. Do not start a live experiment or claim traffic allocation is configured. Show me the variant before publishing."
          }
        ]
      },
      {
        "slug": "publish-page",
        "title": "Publish your site",
        "check": null,
        "body": "publish",
        "options": []
      }
    ]
  },
  {
    "slug": "shopify-suggest-pages",
    "hidden": true,
    "retired": false,
    "requires": [
      "checkout/shopify"
    ],
    "vertical": "ecommerce",
    "tab": "scale",
    "order": 12,
    "kind": "explore",
    "rewardKey": "home-suggest-shopify-pages",
    "completion": "all",
    "title": "Get new page ideas",
    "description": "Spot gaps in your store and plan pages for your next campaign.",
    "comingSoon": false,
    "steps": [
      {
        "slug": "prepare-brief",
        "title": "Suggest my next pages",
        "check": null,
        "options": [
          {
            "id": "start",
            "label": "Suggest my next pages",
            "primary": true,
            "prompt": "Suggest useful new pages for my Shopify store. Reuse my connected catalog, brand, and existing pages, or ask for the store URL. Identify missing customer questions, product stories, and offers. Propose three distinct page ideas with audience, purpose, supporting evidence, and a suggested structure. Mark assumptions and let me choose before building."
          }
        ]
      },
      {
        "slug": "review-result",
        "title": "Your results",
        "check": null,
        "body": "deliverable",
        "completionLabel": "Finish workflow",
        "options": []
      }
    ]
  },
  {
    "slug": "shopify-build-ad-page",
    "art": {
      "scene": "page",
      "page": "ad"
    },
    "hidden": false,
    "retired": false,
    "requires": [
      "checkout/shopify"
    ],
    "vertical": "ecommerce",
    "tab": "scale",
    "order": 14,
    "kind": "explore",
    "rewardKey": "home-build-shopify-ad-page",
    "completion": "all",
    "title": "Turn an ad into a landing page",
    "description": "Keep the ad’s promise consistent from the first click to checkout.",
    "comingSoon": false,
    "launchWorkflowId": "ad-to-lander",
    "steps": [
      {
        "slug": "prepare-brief",
        "output": "page",
        "title": "Choose an ad",
        "check": null,
        "options": [
          {
            "id": "start",
            "label": "Choose an ad",
            "primary": true,
            "prompt": "Build a Shopify landing page from an ad I provide. Confirm the product, audience, offer, and rights to the creative. Match the ad’s promise using my brand and real product data. Show me the draft before publishing."
          }
        ]
      },
      {
        "slug": "publish-page",
        "title": "Publish your site",
        "check": null,
        "body": "publish",
        "options": []
      }
    ]
  },
  {
    "slug": "saas-build-landing-page",
    "art": {
      "scene": "page",
      "page": "landing"
    },
    "vertical": "saas",
    "tab": "scale",
    "order": 0,
    "kind": "setup",
    "rewardKey": "home-page",
    "completion": "all",
    "title": "Build a SaaS landing page",
    "description": "Turn campaign clicks into leads with a page built around one offer.",
    "steps": [
      {
        "slug": "import-brand",
        "title": "Set up Branding",
        "check": "brand-business",
        "body": "brand",
        "options": []
      },
      {
        "slug": "build-page",
        "title": "Build your page",
        "check": null,
        "body": "page",
        "output": "page",
        "pageType": "saas-landing",
        "options": []
      },
      {
        "slug": "publish-page",
        "title": "Publish your site",
        "check": null,
        "body": "publish",
        "options": []
      }
    ]
  },
  {
    "slug": "saas-copy-page",
    "art": {
      "scene": "page",
      "page": "copy"
    },
    "vertical": "saas",
    "tab": "scale",
    "order": 5,
    "kind": "explore",
    "rewardKey": "home-copy-shopify-page",
    "completion": "all",
    "title": "Copy an existing SaaS landing page",
    "description": "Rebuild a page you already like with your company's look and copy.",
    "steps": [
      {
        "slug": "import-brand",
        "title": "Set up Branding",
        "check": "brand-business",
        "body": "brand",
        "options": []
      },
      {
        "slug": "build-page",
        "title": "Copy a page from a URL",
        "check": null,
        "body": "page",
        "output": "page",
        "pageType": "url",
        "options": []
      },
      {
        "slug": "publish-page",
        "title": "Publish your site",
        "check": null,
        "body": "publish",
        "options": []
      }
    ]
  },
  {
    "slug": "saas-copy-competitor-page",
    "art": {
      "scene": "page",
      "page": "competitor"
    },
    "vertical": "saas",
    "tab": "scale",
    "order": 6,
    "kind": "explore",
    "rewardKey": "home-copy-competitor-page",
    "completion": "all",
    "title": "Copy a competitor's SaaS page",
    "description": "Borrow the structure of a page that works for a competitor, told in your own words.",
    "steps": [
      {
        "slug": "import-brand",
        "title": "Set up Branding",
        "check": "brand-business",
        "body": "brand",
        "options": []
      },
      {
        "slug": "build-page",
        "title": "Choose a competitor's page",
        "check": null,
        "body": "page",
        "output": "page",
        "pageType": "competitor",
        "options": []
      },
      {
        "slug": "publish-page",
        "title": "Publish your site",
        "check": null,
        "body": "publish",
        "options": []
      }
    ]
  },
  {
    "slug": "saas-import-figma",
    "art": {
      "scene": "page",
      "page": "figma"
    },
    "vertical": "saas",
    "tab": "scale",
    "order": 13,
    "kind": "explore",
    "rewardKey": "home-import-shopify-figma",
    "completion": "all",
    "title": "Import a Figma design for SaaS",
    "description": "Turn your Figma design into an editable page on your site.",
    "steps": [
      {
        "slug": "import-brand",
        "title": "Set up Branding",
        "check": "brand-business",
        "body": "brand",
        "options": []
      },
      {
        "slug": "build-page",
        "title": "Choose your Figma design",
        "check": null,
        "body": "page",
        "output": "page",
        "pageType": "figma",
        "options": []
      },
      {
        "slug": "publish-page",
        "title": "Publish your site",
        "check": null,
        "body": "publish",
        "options": []
      }
    ]
  },
  {
    "slug": "saas-build-site",
    "art": {
      "scene": "page",
      "page": "site"
    },
    "vertical": "saas",
    "tab": "launch",
    "order": 0,
    "kind": "explore",
    "rewardKey": "home-storefront",
    "completion": "all",
    "title": "Build a SaaS site from scratch",
    "description": "Pick a template and launch your company's site.",
    "steps": [
      {
        "slug": "import-brand",
        "title": "Set up Branding",
        "check": "brand-business",
        "body": "brand",
        "options": []
      },
      {
        "slug": "build-site",
        "title": "Choose a site template",
        "check": null,
        "body": "template",
        "output": "page",
        "templateTags": [
          "Home"
        ],
        "options": []
      },
      {
        "slug": "publish-site",
        "title": "Publish your site",
        "check": null,
        "body": "publish",
        "options": []
      }
    ]
  },
  {
    "slug": "saas-build-feature-page",
    "art": {
      "scene": "page",
      "page": "feature"
    },
    "vertical": "saas",
    "tab": "launch",
    "order": 1,
    "kind": "explore",
    "rewardKey": "home-build-shopify-product-page",
    "completion": "all",
    "title": "Build a feature page",
    "description": "Show what your product does and why teams choose it.",
    "steps": [
      {
        "slug": "import-brand",
        "title": "Set up Branding",
        "check": "brand-business",
        "body": "brand",
        "options": []
      },
      {
        "slug": "build-page",
        "title": "Build your page",
        "check": null,
        "body": "page",
        "output": "page",
        "pageType": "feature",
        "options": []
      },
      {
        "slug": "publish-page",
        "title": "Publish your site",
        "check": null,
        "body": "publish",
        "options": []
      }
    ]
  },
  {
    "slug": "saas-build-pricing-page",
    "art": {
      "scene": "page",
      "page": "pricing"
    },
    "vertical": "saas",
    "tab": "launch",
    "order": 2,
    "kind": "explore",
    "rewardKey": "home-build-shopify-bundle",
    "completion": "all",
    "title": "Build a pricing page",
    "description": "Lay out your plans so visitors can pick one and sign up.",
    "steps": [
      {
        "slug": "import-brand",
        "title": "Set up Branding",
        "check": "brand-business",
        "body": "brand",
        "options": []
      },
      {
        "slug": "build-page",
        "title": "Build your page",
        "check": null,
        "body": "page",
        "output": "page",
        "pageType": "pricing",
        "options": []
      },
      {
        "slug": "publish-page",
        "title": "Publish your site",
        "check": null,
        "body": "publish",
        "options": []
      }
    ]
  },
  {
    "slug": "services-build-landing-page",
    "art": {
      "scene": "page",
      "page": "landing"
    },
    "vertical": "services",
    "continues": "saas-build-landing-page",
    "tab": "scale",
    "order": 0,
    "kind": "setup",
    "rewardKey": "home-page",
    "completion": "all",
    "title": "Build a landing page for an offer",
    "description": "Turn ad clicks into bookings with a page built around one offer.",
    "steps": [
      {
        "slug": "import-brand",
        "title": "Set up Branding",
        "check": "brand-business",
        "body": "brand",
        "options": []
      },
      {
        "slug": "build-page",
        "title": "Describe your offer",
        "check": null,
        "body": "page",
        "output": "page",
        "pageType": "services-landing",
        "options": []
      },
      {
        "slug": "publish-page",
        "title": "Publish your site",
        "check": null,
        "body": "publish",
        "options": []
      }
    ]
  },
  {
    "slug": "services-build-booking-page",
    "art": {
      "scene": "page",
      "page": "booking"
    },
    "vertical": "services",
    "tab": "scale",
    "order": 1,
    "kind": "explore",
    "rewardKey": "home-build-shopify-product-page",
    "completion": "all",
    "title": "Build a booking page",
    "description": "Give clients one page where they book a visit or ask for a quote.",
    "steps": [
      {
        "slug": "import-brand",
        "title": "Set up Branding",
        "check": "brand-business",
        "body": "brand",
        "options": []
      },
      {
        "slug": "build-page",
        "title": "Add your booking link",
        "check": null,
        "body": "page",
        "output": "page",
        "pageType": "booking",
        "options": []
      },
      {
        "slug": "publish-page",
        "title": "Publish your site",
        "check": null,
        "body": "publish",
        "options": []
      }
    ]
  },
  {
    "slug": "services-copy-page",
    "art": {
      "scene": "page",
      "page": "copy"
    },
    "vertical": "services",
    "continues": "saas-copy-page",
    "tab": "scale",
    "order": 5,
    "kind": "explore",
    "rewardKey": "home-copy-shopify-page",
    "completion": "all",
    "title": "Copy an existing page of yours",
    "description": "Rebuild a page you already like with your business's look and copy.",
    "steps": [
      {
        "slug": "import-brand",
        "title": "Set up Branding",
        "check": "brand-business",
        "body": "brand",
        "options": []
      },
      {
        "slug": "build-page",
        "title": "Copy a page from a URL",
        "check": null,
        "body": "page",
        "output": "page",
        "pageType": "url",
        "options": []
      },
      {
        "slug": "publish-page",
        "title": "Publish your site",
        "check": null,
        "body": "publish",
        "options": []
      }
    ]
  },
  {
    "slug": "services-copy-competitor-page",
    "art": {
      "scene": "page",
      "page": "competitor"
    },
    "vertical": "services",
    "continues": "saas-copy-competitor-page",
    "tab": "scale",
    "order": 6,
    "kind": "explore",
    "rewardKey": "home-copy-competitor-page",
    "completion": "all",
    "title": "Copy a competitor's page",
    "description": "Borrow the structure of a page that works for a competitor, told in your own words.",
    "steps": [
      {
        "slug": "import-brand",
        "title": "Set up Branding",
        "check": "brand-business",
        "body": "brand",
        "options": []
      },
      {
        "slug": "build-page",
        "title": "Choose a competitor's page",
        "check": null,
        "body": "page",
        "output": "page",
        "pageType": "competitor",
        "options": []
      },
      {
        "slug": "publish-page",
        "title": "Publish your site",
        "check": null,
        "body": "publish",
        "options": []
      }
    ]
  },
  {
    "slug": "services-build-site",
    "art": {
      "scene": "page",
      "page": "site"
    },
    "vertical": "services",
    "continues": "saas-build-site",
    "tab": "launch",
    "order": 0,
    "kind": "explore",
    "rewardKey": "home-storefront",
    "completion": "all",
    "title": "Build a site for your business",
    "description": "Say what you do and where, and launch a site that brings in clients.",
    "steps": [
      {
        "slug": "import-brand",
        "title": "Set up Branding",
        "check": "brand-business",
        "body": "brand",
        "options": []
      },
      {
        "slug": "build-site",
        "title": "Describe your business",
        "check": null,
        "body": "page",
        "output": "page",
        "pageType": "services-site",
        "options": []
      },
      {
        "slug": "publish-site",
        "title": "Publish your site",
        "check": null,
        "body": "publish",
        "options": []
      }
    ]
  },
  {
    "slug": "services-build-services-page",
    "art": {
      "scene": "page",
      "page": "pricing"
    },
    "vertical": "services",
    "tab": "launch",
    "order": 1,
    "kind": "explore",
    "rewardKey": "home-build-shopify-bundle",
    "completion": "all",
    "title": "Build a services and pricing page",
    "description": "Lay out your services and prices so clients can pick one and book.",
    "steps": [
      {
        "slug": "import-brand",
        "title": "Set up Branding",
        "check": "brand-business",
        "body": "brand",
        "options": []
      },
      {
        "slug": "build-page",
        "title": "List your services and prices",
        "check": null,
        "body": "page",
        "output": "page",
        "pageType": "services-pricing",
        "options": []
      },
      {
        "slug": "publish-page",
        "title": "Publish your site",
        "check": null,
        "body": "publish",
        "options": []
      }
    ]
  },
  {
    "slug": "services-compare-competitor-offers",
    "art": {
      "scene": "board",
      "items": "offers"
    },
    "hidden": true,
    "retired": true,
    "vertical": "services",
    "tab": "research",
    "order": 2,
    "kind": "explore",
    "rewardKey": "home-compare-competitor-offers",
    "completion": "all",
    "title": "Plan your next promotion",
    "description": "Compare competitor offers and draft one you can afford.",
    "steps": [
      {
        "slug": "brand-context",
        "title": "Set up Branding",
        "description": "Use your saved brand, services, and audience for this campaign.",
        "check": "brand-business",
        "body": "brand",
        "gatesWorkflow": true,
        "options": []
      },
      {
        "slug": "compare-offers",
        "title": "Compare competitor offers",
        "check": null,
        "options": [
          {
            "id": "compare",
            "label": "Compare offers",
            "description": "Intro offers, packages, discounts, and guarantees",
            "primary": true,
            "prompt": "Read my existing Branding business context and brand documents first. Reuse my services, audience, positioning, and voice; do not ask me to describe my business again. Ask only for missing information or a campaign-specific choice. Use Sightglass to compare 3 relevant competitors' current advertised offers. Let me replace suggested competitors. Check destination pages and show intro offers, package or membership prices, discounts, free consultations or estimates, and guarantees in a comparison table. Include observed dates and flag unavailable information. Ask which service and promotion I want to plan. Link source ads and pages and distinguish observed patterns from performance claims. Do not infer bookings, conversion rates, spend, or return from ad longevity or duplication. Never invent testimonials, qualifications, or results."
          }
        ]
      },
      {
        "slug": "save-promotion-plan",
        "title": "Draft your promotion",
        "description": "Get the offer, campaign headline, and terms in one brief.",
        "check": null,
        "body": "deliverable",
        "completionLabel": "I’ve saved my promotion plan",
        "options": [
          {
            "id": "plan",
            "label": "Draft promotion plan",
            "description": "Choose an offer you can afford to run",
            "primary": true,
            "prompt": "Read my existing Branding business context and brand documents first. Reuse my services, audience, positioning, and voice; do not ask me to describe my business again. Ask only for missing information or a campaign-specific choice. Use this workflow's competitor offer comparison and my selected service. Ask for the most I can discount, how many new clients I can take on, and the promotion dates. Propose 3 specific offers with their tradeoffs, let me choose one, then write an editable promotion brief with the services it covers, the price or package, headline, landing-page copy, dates, and exclusions. Show any missing cost inputs instead of inventing profitability. Save the brief to workspace files and link it. Do not change my prices or publish anything. Link source ads and pages and distinguish observed patterns from performance claims. Do not infer bookings, conversion rates, spend, or return from ad longevity or duplication. Never invent testimonials, qualifications, or results."
          }
        ]
      }
    ]
  },
  {
    "slug": "services-find-creative-angles",
    "art": {
      "scene": "board",
      "items": "angles"
    },
    "hidden": true,
    "retired": true,
    "vertical": "services",
    "tab": "research",
    "order": 3,
    "kind": "explore",
    "rewardKey": "home-find-creative-angles",
    "completion": "all",
    "title": "Write new ad hooks",
    "description": "Turn client problems into 5 ad hooks for your service.",
    "steps": [
      {
        "slug": "brand-context",
        "title": "Set up Branding",
        "description": "Use your saved brand, services, and audience for this campaign.",
        "check": "brand-business",
        "body": "brand",
        "gatesWorkflow": true,
        "options": []
      },
      {
        "slug": "find-angles",
        "title": "Choose a client problem",
        "check": null,
        "options": [
          {
            "id": "explore",
            "label": "Find messages to test",
            "description": "See how other businesses speak to your clients",
            "primary": true,
            "prompt": "Read my existing Branding business context and brand documents first. Reuse my services, audience, positioning, and voice; do not ask me to describe my business again. Ask only for missing information or a campaign-specific choice. Use Sightglass ads to show 3 distinct client problems or objections to booking relevant to my service. For each, show actual ad examples and the benefit they emphasize. Separate ad messaging from verified client research. Let me select one problem to address and confirm the service if my business offers several. Link source ads and pages and distinguish observed patterns from performance claims. Do not infer bookings, conversion rates, spend, or return from ad longevity or duplication. Never invent testimonials, qualifications, or results."
          }
        ]
      },
      {
        "slug": "save-ad-hooks",
        "title": "Write 5 hooks for your service",
        "description": "Get opening lines, supporting copy, and a visual idea for each.",
        "check": "home-ad-hooks",
        "body": "deliverable",
        "options": [
          {
            "id": "hooks",
            "label": "Write ad hooks",
            "description": "Original copy in your brand’s voice",
            "primary": true,
            "prompt": "Read my existing Branding business context and brand documents first. Reuse my services, audience, positioning, and voice; do not ask me to describe my business again. Ask only for missing information or a campaign-specific choice. Use the client problem and service selected in this workflow. Write 5 distinct original ad hooks, each with a headline, opening spoken line, short body copy, proof, and suggested visual. Use my actual services, benefits and voice. Ask me which hooks to keep or revise, then save the chosen copy as an editable Markdown document in workspace files, with “ad-hooks” in the file name, and link it. Do not generate images or launch ads. Link source ads and pages and distinguish observed patterns from performance claims. Do not infer bookings, conversion rates, spend, or return from ad longevity or duplication. Never invent testimonials, qualifications, or results."
          }
        ]
      }
    ]
  },
  {
    "slug": "research-competitor-ads",
    "art": {
      "scene": "board",
      "items": "competitor-ads"
    },
    "tab": "research",
    "order": 0,
    "kind": "explore",
    "rewardKey": "home-research",
    "completion": "all",
    "title": "Research your competitors' ads",
    "description": "See what brands like yours advertise, choose the best examples, and make your own.",
    "steps": [
      {
        "slug": "brand-context",
        "title": "Set up Branding",
        "description": "Use your saved brand, products, and audience for this campaign.",
        "check": "brand-business",
        "body": "brand",
        "gatesWorkflow": true,
        "options": []
      },
      {
        "slug": "research-category",
        "title": "Choose brands",
        "description": "Pick up to 3 brands selling to the same customer.",
        "check": null,
        "body": "competitors",
        "options": [
          {
            "id": "competitors",
            "label": "Find brands like yours",
            "description": "Pick up to 3 brands selling to the same customer",
            "primary": true,
            "prompt": "Read my existing Branding business context and brand documents first. Reuse my products, audience, positioning, and voice; do not ask me to describe my business again. Ask only for missing information or a campaign-specific choice. Use Sightglass to find 5 brands selling similar products to the same customer. Show each brand's products and positioning with a source link. Let me choose up to 3 brands, or supply my own, for an ad comparison. Link source ads and pages and distinguish observed patterns from performance claims. Do not infer sales, conversion rates, spend, or ROAS from ad longevity or duplication. Never invent testimonials or product claims."
          }
        ]
      },
      {
        "slug": "save-ad-shortlist",
        "title": "Choose ads",
        "description": "Select the ads you want to use as references.",
        "check": null,
        "body": "deliverable",
        "completionLabel": "I’ve chosen my ad examples",
        "finds": "sightglass-ads",
        "keeps": "selection",
        "options": [
          {
            "id": "ads",
            "label": "Find their ads",
            "description": "Compare their messages, offers, and landing pages",
            "primary": true,
            "prompt": "Read my existing Branding business context and brand documents first. Reuse my products, audience, positioning, and voice; do not ask me to describe my business again. Ask only for missing information or a campaign-specific choice. Use the brands I selected in this workflow, and my own brand's ads if Sightglass has any. Retrieve up to 10 relevant ads in Sightglass with source links, available run dates, the offer, and destination page. Show concrete examples grouped by brand. Ask which ads I want to use as references for my own ads. Do not build a landing page. Link source ads and pages and distinguish observed patterns from performance claims. Do not infer sales, conversion rates, spend, or ROAS from ad longevity or duplication. Never invent testimonials or product claims."
          }
        ]
      },
      {
        "slug": "generate-ads",
        "title": "Generate ads",
        "description": "Make your own ads from the ones you selected.",
        "check": null,
        "body": "generate-ads",
        "options": [
          {
            "id": "generate",
            "label": "Generate ads in Canvas",
            "description": "4 ads for your product, in your brand",
            "primary": true,
            "prompt": "Read my existing Branding business context and brand documents first. Reuse my products, audience, positioning, and voice; do not ask me to describe my business again. Ask only for missing information or a campaign-specific choice. Make 4 ads for my product in my saved brand, in 4:5 portrait (1080×1350). Use the ads I chose in this workflow as references; if I have not chosen any, ask me which to use. Follow the ad-direction guide in the building-canvas-sets skill (references/ad-direction.md) and the building-creative-assets skill, and render each ad with Sunburst. From another company’s ad, borrow only the idea: its angle, its format, its type of offer. Write every headline and line new, sharing no phrase and no sentence pattern with the reference. Stage a new scene: do not repeat the reference’s setting, pose, layout or composition, never reuse its imagery, and never imitate a person in it. Use only my brand, product, copy and claims. Never invent reviews, prices or discounts. Copy each reference ad into my Assets with sightglass_copy_creative_to_assets, then build the ads as frames in one new Canvas set, each next to the reference frame it came from, as the building-canvas-sets skill describes. Reply with the set’s link and each ad’s pixel size. In your replies, never name an image model, a tool or a skill: say what you made, not what made it. Do not launch anything. Link source ads and pages and distinguish observed patterns from performance claims. Do not infer sales, conversion rates, spend, or ROAS from ad longevity or duplication. Never invent testimonials or product claims."
          }
        ]
      }
    ]
  },
  {
    "slug": "research-competitor-pages",
    "art": {
      "scene": "board",
      "items": "competitor-pages"
    },
    "tab": "research",
    "order": 1,
    "kind": "explore",
    "rewardKey": "home-research-competitor-pages",
    "completion": "all",
    "title": "Research your competitors' pages",
    "description": "See the landing pages similar brands send their ads to and save the ones worth studying.",
    "steps": [
      {
        "slug": "brand-context",
        "title": "Set up Branding",
        "description": "Use your saved brand, products, and audience for this campaign.",
        "check": "brand-business",
        "body": "brand",
        "gatesWorkflow": true,
        "options": []
      },
      {
        "slug": "save-page-shortlist",
        "title": "Find and save pages",
        "description": "Keep the pages you want to reference in Sightglass.",
        "check": null,
        "body": "deliverable",
        "completionLabel": "I’ve saved my page examples",
        "finds": "sightglass-pages",
        "options": [
          {
            "id": "pages",
            "label": "Find competitor pages",
            "description": "Compare their offers, sections, and page types",
            "primary": true,
            "prompt": "Read my existing Branding business context and brand documents first. Reuse my products, audience, positioning, and voice; do not ask me to describe my business again. Ask only for missing information or a campaign-specific choice. Use Sightglass to find 3 brands selling similar products to the same customer, or use the competitors I name. Retrieve up to 10 of the landing pages their ads point at, with source links, the page type, the offer, and how many ads point at each. Show concrete examples grouped by competitor. Ask which pages I want to keep, then save those pages with Sightglass's existing save tools and show me where to find them. Only report a save after the tool succeeds. Do not build a landing page. Link source ads and pages and distinguish observed patterns from performance claims. Do not infer sales, conversion rates, spend, or ROAS from ad longevity or duplication. Never invent testimonials or product claims."
          }
        ]
      }
    ]
  },
  {
    "slug": "compare-competitor-offers",
    "art": {
      "scene": "board",
      "items": "offers"
    },
    "hidden": true,
    "retired": true,
    "excludedVerticals": [
      "services"
    ],
    "tab": "research",
    "order": 2,
    "kind": "explore",
    "rewardKey": "home-compare-competitor-offers",
    "completion": "all",
    "title": "Plan your next promotion",
    "description": "Compare competitor deals and draft an offer you can afford.",
    "steps": [
      {
        "slug": "brand-context",
        "title": "Set up Branding",
        "description": "Use your saved brand, products, and audience for this campaign.",
        "check": "brand-business",
        "body": "brand",
        "gatesWorkflow": true,
        "options": []
      },
      {
        "slug": "compare-offers",
        "title": "Compare competitor deals",
        "check": null,
        "options": [
          {
            "id": "compare",
            "label": "Compare offers",
            "description": "Prices, bundles, discounts, and shipping deals",
            "primary": true,
            "prompt": "Read my existing Branding business context and brand documents first. Reuse my products, audience, positioning, and voice; do not ask me to describe my business again. Ask only for missing information or a campaign-specific choice. Use Sightglass to compare 3 relevant competitors' current advertised offers. Let me replace suggested competitors. Check destination pages and show prices, bundle contents, discounts, shipping thresholds, and guarantees in a comparison table. Include observed dates and flag unavailable information. Ask which product and promotion I want to plan. Link source ads and pages and distinguish observed patterns from performance claims. Do not infer sales, conversion rates, spend, or ROAS from ad longevity or duplication. Never invent testimonials or product claims."
          }
        ]
      },
      {
        "slug": "save-promotion-plan",
        "title": "Draft your promotion",
        "description": "Get the offer, campaign headline, and terms in one brief.",
        "check": null,
        "body": "deliverable",
        "completionLabel": "I’ve saved my promotion plan",
        "options": [
          {
            "id": "plan",
            "label": "Draft promotion plan",
            "description": "Choose a deal you can afford to run",
            "primary": true,
            "prompt": "Read my existing Branding business context and brand documents first. Reuse my products, audience, positioning, and voice; do not ask me to describe my business again. Ask only for missing information or a campaign-specific choice. Use this workflow's competitor offer comparison and my selected product. Ask for my maximum discount or margin floor, stock constraints, and promotion dates. Propose 3 specific offers with their tradeoffs, let me choose one, then write an editable promotion brief with eligible products, pricing or bundle contents, headline, landing-page copy, dates, and exclusions. Show any missing cost inputs instead of inventing profitability. Save the brief to workspace files and link it. Do not change store prices, create discounts, or publish anything. Link source ads and pages and distinguish observed patterns from performance claims. Do not infer sales, conversion rates, spend, or ROAS from ad longevity or duplication. Never invent testimonials or product claims."
          }
        ]
      }
    ]
  },
  {
    "slug": "find-creative-angles",
    "art": {
      "scene": "board",
      "items": "angles"
    },
    "hidden": true,
    "retired": true,
    "excludedVerticals": [
      "services"
    ],
    "tab": "research",
    "order": 3,
    "kind": "explore",
    "rewardKey": "home-find-creative-angles",
    "completion": "all",
    "title": "Write new ad hooks",
    "description": "Turn customer problems into 5 ad hooks for your product.",
    "steps": [
      {
        "slug": "brand-context",
        "title": "Set up Branding",
        "description": "Use your saved brand, products, and audience for this campaign.",
        "check": "brand-business",
        "body": "brand",
        "gatesWorkflow": true,
        "options": []
      },
      {
        "slug": "find-angles",
        "title": "Choose a customer problem",
        "check": null,
        "options": [
          {
            "id": "explore",
            "label": "Find messages to test",
            "description": "See how other brands speak to your customer",
            "primary": true,
            "prompt": "Read my existing Branding business context and brand documents first. Reuse my products, audience, positioning, and voice; do not ask me to describe my business again. Ask only for missing information or a campaign-specific choice. Use Sightglass ads to show 3 distinct customer problems or buying objections relevant to my product. For each, show actual ad examples and the product benefit they emphasize. Separate ad messaging from verified customer research. Let me select one problem to address and confirm the product if my brand sells several. Link source ads and pages and distinguish observed patterns from performance claims. Do not infer sales, conversion rates, spend, or ROAS from ad longevity or duplication. Never invent testimonials or product claims."
          }
        ]
      },
      {
        "slug": "save-ad-hooks",
        "title": "Write 5 hooks for your product",
        "description": "Get opening lines, supporting copy, and a visual idea for each.",
        "check": "home-ad-hooks",
        "body": "deliverable",
        "options": [
          {
            "id": "hooks",
            "label": "Write ad hooks",
            "description": "Original copy in your brand’s voice",
            "primary": true,
            "prompt": "Read my existing Branding business context and brand documents first. Reuse my products, audience, positioning, and voice; do not ask me to describe my business again. Ask only for missing information or a campaign-specific choice. Use the customer problem and product selected in this workflow. Write 5 distinct original ad hooks, each with a headline, opening spoken line, short body copy, product proof, and suggested visual. Use my actual product benefits and voice. Ask me which hooks to keep or revise, then save the chosen copy as an editable Markdown document in workspace files, with “ad-hooks” in the file name, and link it. Do not generate images or launch ads. Link source ads and pages and distinguish observed patterns from performance claims. Do not infer sales, conversion rates, spend, or ROAS from ad longevity or duplication. Never invent testimonials or product claims."
          }
        ]
      }
    ]
  },
  {
    "slug": "build-swipe-file",
    "art": {
      "scene": "board",
      "items": "swipe-file"
    },
    "hidden": true,
    "retired": true,
    "tab": "research",
    "order": 4,
    "kind": "explore",
    "rewardKey": "home-build-swipe-file",
    "completion": "all",
    "title": "Build a campaign swipe file",
    "description": "Collect ad and page references to share with your creative team.",
    "steps": [
      {
        "slug": "brand-context",
        "title": "Set up Branding",
        "description": "Use your saved brand, products, and audience for this campaign.",
        "check": "brand-business",
        "body": "brand",
        "gatesWorkflow": true,
        "options": []
      },
      {
        "slug": "curate-examples",
        "title": "Choose what you’re making",
        "check": null,
        "options": [
          {
            "id": "references",
            "label": "Find campaign references",
            "description": "A product launch, seasonal sale, or evergreen campaign",
            "primary": true,
            "prompt": "Read my existing Branding business context and brand documents first. Reuse my products, audience, positioning, and voice; do not ask me to describe my business again. Ask only for missing information or a campaign-specific choice. Ask whether I am preparing a product launch, seasonal promotion, or evergreen campaign, and which product it is for. Search Sightglass for up to 10 relevant ads and landing pages, including useful examples outside my direct competitors. Show the actual references with a short explanation of the format, offer, or page structure worth considering. Let me select the examples to keep. Link source ads and pages and distinguish observed patterns from performance claims. Do not infer sales, conversion rates, spend, or ROAS from ad longevity or duplication. Never invent testimonials or product claims."
          }
        ]
      },
      {
        "slug": "save-campaign-references",
        "title": "Save your campaign references",
        "description": "Keep your selections together with notes for your team.",
        "check": null,
        "body": "deliverable",
        "completionLabel": "I’ve saved my campaign references",
        "finds": "sightglass-ads",
        "options": [
          {
            "id": "save",
            "label": "Save selected references",
            "description": "Add your picks to Sightglass and write the notes",
            "primary": true,
            "prompt": "Read my existing Branding business context and brand documents first. Reuse my products, audience, positioning, and voice; do not ask me to describe my business again. Ask only for missing information or a campaign-specific choice. Use the campaign references I selected in this workflow. If none have been selected, show the shortlist and ask me to choose. Save the selected ads and landing pages using Sightglass's existing save tools; confirm each successful save and report any failures. Create an editable campaign reference document in workspace files with links, what I liked about each example, and notes for the designer. Link the document and tell me where the references appear in Sightglass. Suggest original adaptations, not copying another brand's assets. Link source ads and pages and distinguish observed patterns from performance claims. Do not infer sales, conversion rates, spend, or ROAS from ad longevity or duplication. Never invent testimonials or product claims."
          }
        ]
      }
    ]
  },
  {
    "slug": "write-creative-brief",
    "hidden": true,
    "retired": true,
    "tab": "research",
    "order": 5,
    "kind": "explore",
    "rewardKey": "home-write-creative-brief",
    "completion": "all",
    "title": "Brief a video creator",
    "description": "Give a creator a product brief, a 30-second script, and a shot list.",
    "steps": [
      {
        "slug": "brand-context",
        "title": "Set up Branding",
        "description": "Use your saved brand, products, and audience for this campaign.",
        "check": "brand-business",
        "body": "brand",
        "gatesWorkflow": true,
        "options": []
      },
      {
        "slug": "draft-brief",
        "title": "Choose the product and message",
        "check": null,
        "options": [
          {
            "id": "direction",
            "label": "Plan the video",
            "description": "Pick the product, offer, and one message to get across",
            "primary": true,
            "prompt": "Read my existing Branding business context and brand documents first. Reuse my products, audience, positioning, and voice; do not ask me to describe my business again. Ask only for missing information or a campaign-specific choice. Help me brief a creator for a 30-second product video. Use my saved brand context and ask only which product, offer, channel, and one key message the video should focus on. Use selected Sightglass references if available; otherwise find 3 relevant video ad examples and let me pick a direction. Confirm available product footage or samples and any required deliverable formats. Link source ads and pages and distinguish observed patterns from performance claims. Do not infer sales, conversion rates, spend, or ROAS from ad longevity or duplication. Never invent testimonials or product claims."
          }
        ]
      },
      {
        "slug": "save-creator-brief",
        "title": "Write the creator brief",
        "description": "A script and shot list ready to hand to your creator.",
        "check": null,
        "body": "deliverable",
        "completionLabel": "I’ve saved my creator brief",
        "options": [
          {
            "id": "brief",
            "label": "Write creator brief",
            "description": "Hook, product demo, proof, and call to action",
            "primary": true,
            "prompt": "Read my existing Branding business context and brand documents first. Reuse my products, audience, positioning, and voice; do not ask me to describe my business again. Ask only for missing information or a campaign-specific choice. Use the product, message, channel, offer, and references chosen in this workflow. Write an editable creator brief with the audience, key message, a timed 30-second script, shot list, product demonstration, on-screen copy, call to action, deliverable formats, and assets the creator needs. Use verified product proof and flag missing assets. Ask for revisions, then save the brief in workspace files and link it. Do not send it to anyone, generate a video, or publish ads. Link source ads and pages and distinguish observed patterns from performance claims. Do not infer sales, conversion rates, spend, or ROAS from ad longevity or duplication. Never invent testimonials or product claims."
          }
        ]
      }
    ]
  },
  {
    "slug": "site-domain-setup",
    "miniappId": "website-builder",
    "hidden": true,
    "tab": "build",
    "order": 0,
    "kind": "setup",
    "rewardKey": null,
    "completion": "all",
    "title": "Connect your domain",
    "description": "Choose your launch address and check that visitors can reach it.",
    "steps": [
      {
        "slug": "choose-domain",
        "title": "Choose a domain",
        "description": "Choose the site and domain you want to launch.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Choose the site and domain you want to launch. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      },
      {
        "slug": "connect-domain",
        "title": "Connect and verify DNS",
        "description": "Add the required DNS records, then verify the domain is ready.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Add the required DNS records, then verify the domain is ready. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      },
      {
        "slug": "check-address",
        "title": "Check your live address",
        "description": "Open the intended address and confirm it serves the right site.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Open the intended address and confirm it serves the right site. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      }
    ]
  },
  {
    "slug": "site-tracking-setup",
    "miniappId": "website-builder",
    "hidden": true,
    "tab": "build",
    "order": 0,
    "kind": "setup",
    "rewardKey": null,
    "completion": "all",
    "title": "Set up tracking",
    "description": "Connect analytics and check the events you need to measure.",
    "steps": [
      {
        "slug": "choose-tracking",
        "title": "Choose analytics and pixels",
        "description": "Choose the analytics and advertising tools you use.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Choose the analytics and advertising tools you use. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      },
      {
        "slug": "configure-tracking",
        "title": "Add tracking and consent settings",
        "description": "Set up the required IDs or scripts and review when they load.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Set up the required IDs or scripts and review when they load. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      },
      {
        "slug": "verify-events",
        "title": "Verify your events",
        "description": "Use your analytics or pixel testing tools to check page views and your key conversion events.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Use your analytics or pixel testing tools to check page views and your key conversion events. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      }
    ]
  },
  {
    "slug": "site-seo-setup",
    "miniappId": "website-builder",
    "hidden": true,
    "tab": "build",
    "order": 0,
    "kind": "setup",
    "rewardKey": null,
    "completion": "all",
    "title": "Review SEO and launch",
    "description": "Check search visibility and preview the site before publishing.",
    "steps": [
      {
        "slug": "review-metadata",
        "title": "Review titles and descriptions",
        "description": "Review the page titles, descriptions, and social sharing images for your launch pages.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Review the page titles, descriptions, and social sharing images for your launch pages. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      },
      {
        "slug": "review-indexing",
        "title": "Check search visibility",
        "description": "Review indexing, sitemap, canonical URLs, and any redirects needed for existing pages.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Review indexing, sitemap, canonical URLs, and any redirects needed for existing pages. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      },
      {
        "slug": "review-launch",
        "title": "Preview and publish",
        "description": "Check mobile layouts, links, and purchase or signup actions before explicitly publishing.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Check mobile layouts, links, and purchase or signup actions before explicitly publishing. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      }
    ]
  },
  {
    "slug": "product-setup",
    "miniappId": "products",
    "hidden": true,
    "tab": "build",
    "order": 0,
    "kind": "setup",
    "rewardKey": null,
    "completion": "all",
    "title": "Prepare your first product",
    "description": "Create or import a product and review what customers will buy.",
    "steps": [
      {
        "slug": "create-product",
        "title": "Create or import a product",
        "description": "Create a product or import one from your connected store.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Create a product or import one from your connected store. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      },
      {
        "slug": "review-product",
        "title": "Review product details",
        "description": "Check its images, description, price, and fulfillment details.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Check its images, description, price, and fulfillment details. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      },
      {
        "slug": "review-offer",
        "title": "Review the offer",
        "description": "Check that the product is ready to use on a page.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Check that the product is ready to use on a page. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      }
    ]
  },
  {
    "slug": "brand-setup",
    "miniappId": "brand-studio",
    "hidden": true,
    "tab": "build",
    "order": 0,
    "kind": "setup",
    "rewardKey": null,
    "completion": "all",
    "title": "Set up your brand",
    "description": "Bring your identity and voice into your next project.",
    "steps": [
      {
        "slug": "import-brand",
        "title": "Import or create a brand",
        "description": "Use your website or start with your own brand details.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Use your website or start with your own brand details. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      },
      {
        "slug": "review-brand",
        "title": "Review your identity",
        "description": "Review the logo, palette, typography, and voice.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Review the logo, palette, typography, and voice. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      },
      {
        "slug": "save-brand",
        "title": "Save your brand",
        "description": "Save the brand you want to use in your work.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Save the brand you want to use in your work. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      }
    ]
  },
  {
    "slug": "asset-setup",
    "miniappId": "assets",
    "hidden": true,
    "tab": "build",
    "order": 0,
    "kind": "setup",
    "rewardKey": null,
    "completion": "all",
    "title": "Build your asset library",
    "description": "Bring in the images and files you need for your next project.",
    "steps": [
      {
        "slug": "add-assets",
        "title": "Add your assets",
        "description": "Upload, import, or generate assets for your project.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Upload, import, or generate assets for your project. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      },
      {
        "slug": "review-assets",
        "title": "Review your assets",
        "description": "Check the images, file names, and formats.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Check the images, file names, and formats. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      },
      {
        "slug": "choose-asset",
        "title": "Choose an asset to use",
        "description": "Choose an asset for your page, product, or campaign.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Choose an asset for your page, product, or campaign. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      }
    ]
  },
  {
    "slug": "content-setup",
    "miniappId": "content",
    "hidden": true,
    "tab": "build",
    "order": 0,
    "kind": "setup",
    "rewardKey": null,
    "completion": "all",
    "title": "Create your first collection",
    "description": "Organize content and add your first entry.",
    "steps": [
      {
        "slug": "choose-site",
        "title": "Choose a site",
        "description": "Choose where your content will be used.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Choose where your content will be used. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      },
      {
        "slug": "create-collection",
        "title": "Create a collection",
        "description": "Choose a preset or define the fields you need.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Choose a preset or define the fields you need. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      },
      {
        "slug": "create-entry",
        "title": "Add your first entry",
        "description": "Create and review an entry in your collection.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Create and review an entry in your collection. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      }
    ]
  },
  {
    "slug": "canvas-setup",
    "miniappId": "canvas",
    "hidden": true,
    "tab": "build",
    "order": 0,
    "kind": "setup",
    "rewardKey": null,
    "completion": "all",
    "title": "Create your first creative set",
    "description": "Build and review the creatives for a campaign.",
    "steps": [
      {
        "slug": "create-set",
        "title": "Create a set",
        "description": "Name a set for your campaign.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Name a set for your campaign. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      },
      {
        "slug": "create-creative",
        "title": "Create your first creative",
        "description": "Add the images, copy, and sizes you need.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Add the images, copy, and sizes you need. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      },
      {
        "slug": "review-creative",
        "title": "Review your creative",
        "description": "Check the content and layout at each size.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Check the content and layout at each size. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      }
    ]
  },
  {
    "slug": "research-setup",
    "miniappId": "sightglass",
    "hidden": true,
    "tab": "build",
    "order": 0,
    "kind": "setup",
    "rewardKey": null,
    "completion": "all",
    "title": "Research your next campaign",
    "description": "Find useful examples and choose a direction.",
    "steps": [
      {
        "slug": "choose-topic",
        "title": "Choose a research topic",
        "description": "Choose a product, category, or competitor to research.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Choose a product, category, or competitor to research. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      },
      {
        "slug": "inspect-ads",
        "title": "Inspect examples",
        "description": "Review ads and landing pages relevant to your campaign.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Review ads and landing pages relevant to your campaign. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      },
      {
        "slug": "choose-reference",
        "title": "Choose a reference",
        "description": "Choose an example and describe what you want to learn from it.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Choose an example and describe what you want to learn from it. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      }
    ]
  },
  {
    "slug": "file-setup",
    "miniappId": "files",
    "hidden": true,
    "tab": "build",
    "order": 0,
    "kind": "setup",
    "rewardKey": null,
    "completion": "all",
    "title": "Organize your project files",
    "description": "Add files and make them easy to find.",
    "steps": [
      {
        "slug": "add-file",
        "title": "Add a file",
        "description": "Upload or create a file for your project.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Upload or create a file for your project. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      },
      {
        "slug": "organize-files",
        "title": "Organize your files",
        "description": "Name and organize files in the right location.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Name and organize files in the right location. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      },
      {
        "slug": "open-file",
        "title": "Review a file",
        "description": "Open a file and check its contents.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Open a file and check its contents. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      }
    ]
  },
  {
    "slug": "order-setup",
    "miniappId": "orders",
    "hidden": true,
    "tab": "build",
    "order": 0,
    "kind": "setup",
    "rewardKey": null,
    "completion": "all",
    "title": "Prepare to receive orders",
    "description": "Review your product and checkout setup before selling.",
    "steps": [
      {
        "slug": "prepare-product",
        "title": "Prepare a product",
        "description": "Create or review the product you intend to sell.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Create or review the product you intend to sell. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      },
      {
        "slug": "review-checkout",
        "title": "Review checkout",
        "description": "Check payments and the checkout experience.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Check payments and the checkout experience. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      },
      {
        "slug": "review-notifications",
        "title": "Review order notifications",
        "description": "Review your order emails and notification settings.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Review your order emails and notification settings. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      }
    ]
  },
  {
    "slug": "report-setup",
    "miniappId": "insights",
    "hidden": true,
    "tab": "build",
    "order": 0,
    "kind": "setup",
    "rewardKey": null,
    "completion": "all",
    "title": "Create your first report",
    "description": "Turn a question into a report you can revisit.",
    "steps": [
      {
        "slug": "choose-question",
        "title": "Choose a question",
        "description": "Choose what you want to understand about your business.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Choose what you want to understand about your business. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      },
      {
        "slug": "choose-data",
        "title": "Choose your data",
        "description": "Connect or select the data needed for that question.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Connect or select the data needed for that question. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      },
      {
        "slug": "create-report",
        "title": "Create and review a report",
        "description": "Create the report and check what its results tell you.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Create the report and check what its results tell you. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      }
    ]
  },
  {
    "slug": "plan-setup",
    "miniappId": "plans",
    "hidden": true,
    "tab": "build",
    "order": 0,
    "kind": "setup",
    "rewardKey": null,
    "completion": "all",
    "title": "Plan your next project",
    "description": "Turn a brief into concrete next steps.",
    "steps": [
      {
        "slug": "choose-brief",
        "title": "Choose a brief",
        "description": "Describe your goal or start with a plan template.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Describe your goal or start with a plan template. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      },
      {
        "slug": "create-plan",
        "title": "Create a plan",
        "description": "Build the plan around your goal and constraints.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Build the plan around your goal and constraints. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      },
      {
        "slug": "review-plan",
        "title": "Review next steps",
        "description": "Review the proposed work before starting it.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Review the proposed work before starting it. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      }
    ]
  },
  {
    "slug": "task-setup",
    "miniappId": "tasks",
    "hidden": true,
    "tab": "build",
    "order": 0,
    "kind": "setup",
    "rewardKey": null,
    "completion": "all",
    "title": "Set up a recurring task",
    "description": "Decide what should run, when, and where to review it.",
    "steps": [
      {
        "slug": "describe-task",
        "title": "Describe the work",
        "description": "Write what you want the task to do.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Write what you want the task to do. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      },
      {
        "slug": "schedule-task",
        "title": "Set its schedule",
        "description": "Choose when the task should run and review its instructions.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Choose when the task should run and review its instructions. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      },
      {
        "slug": "enable-task",
        "title": "Review and enable",
        "description": "Explicitly enable the task when you are ready for it to run.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Explicitly enable the task when you are ready for it to run. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      }
    ]
  },
  {
    "slug": "skill-setup",
    "miniappId": "skills",
    "hidden": true,
    "tab": "build",
    "order": 0,
    "kind": "setup",
    "rewardKey": null,
    "completion": "all",
    "title": "Create your first skill",
    "description": "Save instructions you can reuse across your work.",
    "steps": [
      {
        "slug": "choose-skill",
        "title": "Choose a starting point",
        "description": "Choose a template or start a blank skill.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Choose a template or start a blank skill. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      },
      {
        "slug": "write-skill",
        "title": "Write the instructions",
        "description": "Describe when to use the skill and what it should do.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Describe when to use the skill and what it should do. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      },
      {
        "slug": "save-skill",
        "title": "Review and save",
        "description": "Review the instructions and save the skill.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Review the instructions and save the skill. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      }
    ]
  },
  {
    "slug": "integration-setup",
    "miniappId": "integrations",
    "hidden": true,
    "tab": "build",
    "order": 0,
    "kind": "setup",
    "rewardKey": null,
    "completion": "all",
    "title": "Connect your tools",
    "description": "Start with tools found on your site, or choose from the catalog.",
    "steps": [
      {
        "slug": "choose-tool",
        "title": "Choose your tools",
        "description": "Review tools detected on your website and choose what to connect.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Review tools detected on your website and choose what to connect. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      },
      {
        "slug": "connect-tools",
        "title": "Connect the tools you use",
        "description": "Complete the connection flow for each tool you need.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Complete the connection flow for each tool you need. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      },
      {
        "slug": "verify-connections",
        "title": "Review your connections",
        "description": "Check that your chosen tools are connected and resolve any reconnect requests.",
        "check": null,
        "options": [
          {
            "id": "guide",
            "label": "Guide me",
            "prompt": "Help me with this step: Check that your chosen tools are connected and resolve any reconnect requests. Ask for the information you need before making changes. Do not publish, connect an account, or enable a scheduled task without my explicit instruction."
          }
        ]
      }
    ]
  },
  {
    "slug": "connect-store",
    "art": {
      "scene": "outcome",
      "outcome": "integrations"
    },
    "hidden": true,
    "retired": true,
    "requires": [
      "checkout/shopify"
    ],
    "vertical": "ecommerce",
    "tab": "scale",
    "order": 1,
    "kind": "setup",
    "rewardKey": "home-store",
    "completion": "all",
    "title": "Connect your Shopify store",
    "description": "Use your live catalog and pricing to build pages for your store.",
    "steps": [
      {
        "slug": "connect-store",
        "title": "Connect your store",
        "check": "has-connected-shopify",
        "body": "shopify",
        "options": []
      },
      {
        "slug": "connect-other",
        "title": "Connect a different tool",
        "optional": true,
        "check": null,
        "options": [
          {
            "id": "other",
            "label": "Connect a different tool",
            "description": "Replo starts with what it found on your site",
            "primary": true,
            "prompt": "Help me connect a tool I use.\n\nStart with any tools found on my website, and let me choose."
          }
        ]
      }
    ]
  },
  {
    "slug": "connect-slack-or-assistant",
    "art": {
      "scene": "outcome",
      "outcome": "connection"
    },
    "hidden": true,
    "retired": true,
    "tab": "integrations",
    "order": 2,
    "kind": "setup",
    "rewardKey": "home-connection",
    "completion": "any",
    "title": "Use Replo from Slack or Claude",
    "description": "Bring your team’s page requests and project updates into one chat.",
    "steps": [
      {
        "slug": "connect-assistant",
        "title": "Connect ChatGPT or Claude",
        "check": "has-connected-assistant",
        "body": "tools",
        "tools": [
          "chatgpt",
          "claude"
        ],
        "options": []
      },
      {
        "slug": "connect-slack",
        "title": "Connect Slack",
        "description": "Ask Replo for pages and updates from a channel.",
        "optional": true,
        "check": "connect-slack",
        "body": "tools",
        "tools": [
          "slack"
        ],
        "options": []
      }
    ]
  },
  {
    "slug": "use-replo-from-slack",
    "art": {
      "scene": "chat",
      "apps": [
        "slack"
      ]
    },
    "externalApp": "slack",
    "tab": "integrations",
    "order": 2,
    "kind": "explore",
    "rewardKey": "home-slack",
    "completion": "all",
    "title": "Use Replo from Slack",
    "description": "Request page edits and get project updates without leaving Slack.",
    "steps": [
      {
        "slug": "connect-slack",
        "title": "Connect Replo to Slack",
        "check": "connect-slack",
        "body": "external-connect",
        "options": []
      },
      {
        "slug": "try-slack-prompt",
        "title": "Try a prompt in Slack",
        "check": null,
        "body": "external-prompt",
        "options": []
      }
    ]
  },
  {
    "slug": "use-replo-from-claude",
    "art": {
      "scene": "chat",
      "apps": [
        "claude"
      ]
    },
    "externalApp": "claude",
    "tab": "integrations",
    "order": 3,
    "kind": "explore",
    "rewardKey": "home-claude",
    "completion": "all",
    "title": "Use Replo from Claude",
    "description": "Request page edits and get project updates without leaving Claude.",
    "steps": [
      {
        "slug": "connect-claude",
        "title": "Connect Replo to Claude",
        "check": "assistant-connected-claude",
        "body": "external-connect",
        "options": []
      },
      {
        "slug": "try-claude-prompt",
        "title": "Try a prompt in Claude",
        "check": null,
        "body": "external-prompt",
        "options": []
      }
    ]
  },
  {
    "slug": "use-replo-from-chatgpt",
    "art": {
      "scene": "chat",
      "apps": [
        "chatgpt"
      ]
    },
    "externalApp": "chatgpt",
    "tab": "integrations",
    "order": 4,
    "kind": "explore",
    "rewardKey": "home-chatgpt",
    "completion": "all",
    "title": "Use Replo from ChatGPT",
    "description": "Request page edits and get project updates without leaving ChatGPT.",
    "steps": [
      {
        "slug": "connect-chatgpt",
        "title": "Connect Replo to ChatGPT",
        "check": "assistant-connected-chatgpt",
        "body": "external-connect",
        "options": []
      },
      {
        "slug": "try-chatgpt-prompt",
        "title": "Try a prompt in ChatGPT",
        "check": null,
        "body": "external-prompt",
        "options": []
      }
    ]
  },
  {
    "slug": "use-klaviyo",
    "art": {
      "scene": "app",
      "app": "klaviyo"
    },
    "integration": "klaviyo",
    "vertical": "ecommerce",
    "tab": "integrations",
    "order": 5,
    "kind": "explore",
    "rewardKey": "home-use-klaviyo",
    "completion": "all",
    "title": "Use Klaviyo in Replo",
    "description": "See which email campaigns earn the most, and build pages around them.",
    "steps": [
      {
        "slug": "connect-klaviyo",
        "title": "Connect Klaviyo",
        "check": "connected-klaviyo",
        "body": "tools",
        "tools": [
          "klaviyo"
        ],
        "gatesWorkflow": true,
        "options": []
      },
      {
        "slug": "try-klaviyo-prompt",
        "title": "Ask Replo about Klaviyo",
        "check": null,
        "options": [
          {
            "id": "first-prompt",
            "label": "Review my recent campaigns",
            "prompt": "Use Klaviyo to review my recent email campaigns.\n\nShow my lists with their sizes, then my last five campaigns with open rate, click rate and revenue. Tell me which campaign did best and suggest one landing page I could build for it. Don’t create or change anything.",
            "primary": true
          }
        ]
      }
    ]
  },
  {
    "slug": "use-meta-marketing-api",
    "art": {
      "scene": "app",
      "app": "meta-marketing-api"
    },
    "integration": "meta-marketing-api",
    "tab": "integrations",
    "order": 6,
    "kind": "explore",
    "rewardKey": "home-use-meta-marketing-api",
    "completion": "all",
    "title": "Use Meta Ads in Replo",
    "description": "Read spend, ROAS and creatives by campaign, and match pages to your best ads.",
    "steps": [
      {
        "slug": "connect-meta-marketing-api",
        "title": "Connect Meta Ads",
        "check": "connected-meta-marketing-api",
        "body": "tools",
        "tools": [
          "meta-marketing-api"
        ],
        "gatesWorkflow": true,
        "options": []
      },
      {
        "slug": "try-meta-marketing-api-prompt",
        "title": "Ask Replo about Meta Ads",
        "check": null,
        "options": [
          {
            "id": "first-prompt",
            "label": "Review my campaigns",
            "prompt": "Use Meta Ads to review my campaigns over the last 30 days.\n\nShow spend, ROAS, CTR and purchases by campaign. Tell me which ad is working best and which landing page it sends people to, then suggest one change to that page. Don’t create or change anything.",
            "primary": true
          }
        ]
      }
    ]
  },
  {
    "slug": "use-google-ads",
    "art": {
      "scene": "app",
      "app": "google-ads"
    },
    "integration": "google-ads",
    "tab": "integrations",
    "order": 7,
    "kind": "explore",
    "rewardKey": "home-use-google-ads",
    "completion": "all",
    "title": "Use Google Ads in Replo",
    "description": "Read spend, clicks and conversions by campaign, and fix the pages they land on.",
    "steps": [
      {
        "slug": "connect-google-ads",
        "title": "Connect Google Ads",
        "check": "connected-google-ads",
        "body": "tools",
        "tools": [
          "google-ads"
        ],
        "gatesWorkflow": true,
        "options": []
      },
      {
        "slug": "try-google-ads-prompt",
        "title": "Ask Replo about Google Ads",
        "check": null,
        "options": [
          {
            "id": "first-prompt",
            "label": "Review my campaigns",
            "prompt": "Use Google Ads to review my campaigns this month.\n\nShow cost, clicks, conversions and cost per conversion by campaign. Tell me which campaign spends the most for the least, and which landing page it sends people to. Don’t create or change anything.",
            "primary": true
          }
        ]
      }
    ]
  },
  {
    "slug": "use-google-analytics",
    "art": {
      "scene": "app",
      "app": "google-analytics"
    },
    "integration": "google-analytics",
    "tab": "integrations",
    "order": 8,
    "kind": "explore",
    "rewardKey": "home-use-google-analytics",
    "completion": "all",
    "title": "Use Google Analytics in Replo",
    "description": "See which pages and sources bring visitors, and where they drop off.",
    "steps": [
      {
        "slug": "connect-google-analytics",
        "title": "Connect Google Analytics",
        "check": "connected-google-analytics",
        "body": "tools",
        "tools": [
          "google-analytics"
        ],
        "gatesWorkflow": true,
        "options": []
      },
      {
        "slug": "try-google-analytics-prompt",
        "title": "Ask Replo about Google Analytics",
        "check": null,
        "options": [
          {
            "id": "first-prompt",
            "label": "Review my traffic",
            "prompt": "Use Google Analytics to review my traffic over the last 30 days.\n\nShow sessions, users and conversions, then my top five pages and top five sources. Tell me which page gets the most traffic and converts the worst. Don’t change anything.",
            "primary": true
          }
        ]
      }
    ]
  },
  {
    "slug": "use-google-search-console",
    "art": {
      "scene": "app",
      "app": "google-search-console"
    },
    "integration": "google-search-console",
    "tab": "integrations",
    "order": 9,
    "kind": "explore",
    "rewardKey": "home-use-google-search-console",
    "completion": "all",
    "title": "Use Google Search Console in Replo",
    "description": "See the searches that bring people to your site, and the pages that rank for them.",
    "steps": [
      {
        "slug": "connect-google-search-console",
        "title": "Connect Google Search Console",
        "check": "connected-google-search-console",
        "body": "tools",
        "tools": [
          "google-search-console"
        ],
        "gatesWorkflow": true,
        "options": []
      },
      {
        "slug": "try-google-search-console-prompt",
        "title": "Ask Replo about Google Search Console",
        "check": null,
        "options": [
          {
            "id": "first-prompt",
            "label": "Review my search queries",
            "prompt": "Use Google Search Console to review my search performance over the last 28 days.\n\nShow my top ten queries with clicks, impressions, CTR and average position. Tell me which queries sit just off the first page and which page I should improve to win them. Don’t change anything.",
            "primary": true
          }
        ]
      }
    ]
  },
  {
    "slug": "use-figma",
    "art": {
      "scene": "app",
      "app": "figma"
    },
    "integration": "figma",
    "tab": "integrations",
    "order": 10,
    "kind": "explore",
    "rewardKey": "home-use-figma",
    "completion": "all",
    "title": "Use Figma in Replo",
    "description": "Point Replo at a design file and build the page your designer drew.",
    "steps": [
      {
        "slug": "connect-figma",
        "title": "Connect Figma",
        "check": "connected-figma",
        "body": "tools",
        "tools": [
          "figma"
        ],
        "gatesWorkflow": true,
        "options": []
      },
      {
        "slug": "try-figma-prompt",
        "title": "Ask Replo about Figma",
        "check": null,
        "options": [
          {
            "id": "first-prompt",
            "label": "Read a design file",
            "prompt": "Use Figma to read my design file.\n\nI’ll paste the link to a frame next. List its sections, fonts and colors, and tell me anything that would be hard to build as drawn before you start. Don’t build anything yet.",
            "primary": true
          }
        ]
      }
    ]
  },
  {
    "slug": "use-notion",
    "art": {
      "scene": "app",
      "app": "notion"
    },
    "integration": "notion",
    "tab": "integrations",
    "order": 11,
    "kind": "explore",
    "rewardKey": "home-use-notion",
    "completion": "all",
    "title": "Use Notion in Replo",
    "description": "Turn briefs, messaging docs and launch plans into pages without copying them over.",
    "steps": [
      {
        "slug": "connect-notion",
        "title": "Connect Notion",
        "check": "connected-notion",
        "body": "tools",
        "tools": [
          "notion"
        ],
        "gatesWorkflow": true,
        "options": []
      },
      {
        "slug": "try-notion-prompt",
        "title": "Ask Replo about Notion",
        "check": null,
        "options": [
          {
            "id": "first-prompt",
            "label": "Find my briefs",
            "prompt": "Use Notion to find what my team has written about our brand and upcoming launches.\n\nList the pages and databases you can see, then summarize the most recent brief in five bullets and suggest the page I should build from it. Don’t create or change anything in Notion.",
            "primary": true
          }
        ]
      }
    ]
  },
  {
    "slug": "use-linear",
    "art": {
      "scene": "app",
      "app": "linear"
    },
    "integration": "linear",
    "excludedVerticals": [
      "services"
    ],
    "tab": "integrations",
    "order": 12,
    "kind": "explore",
    "rewardKey": "home-use-linear",
    "completion": "all",
    "title": "Use Linear in Replo",
    "description": "Pull page requests from your team’s issues and report back when they ship.",
    "steps": [
      {
        "slug": "connect-linear",
        "title": "Connect Linear",
        "check": "connected-linear",
        "body": "tools",
        "tools": [
          "linear"
        ],
        "gatesWorkflow": true,
        "options": []
      },
      {
        "slug": "try-linear-prompt",
        "title": "Ask Replo about Linear",
        "check": null,
        "options": [
          {
            "id": "first-prompt",
            "label": "Find page requests",
            "prompt": "Use Linear to find open issues about our website or landing pages.\n\nList them by team with status, assignee and priority. Tell me which ones you could do in Replo right now. Don’t create or change anything in Linear.",
            "primary": true
          }
        ]
      }
    ]
  },
  {
    "slug": "use-posthog",
    "art": {
      "scene": "app",
      "app": "posthog"
    },
    "integration": "posthog",
    "excludedVerticals": [
      "services"
    ],
    "tab": "integrations",
    "order": 13,
    "kind": "explore",
    "rewardKey": "home-use-posthog",
    "completion": "all",
    "title": "Use PostHog in Replo",
    "description": "See top pages, events and funnels, and find where visitors stop.",
    "steps": [
      {
        "slug": "connect-posthog",
        "title": "Connect PostHog",
        "check": "connected-posthog",
        "body": "tools",
        "tools": [
          "posthog"
        ],
        "gatesWorkflow": true,
        "options": []
      },
      {
        "slug": "try-posthog-prompt",
        "title": "Ask Replo about PostHog",
        "check": null,
        "options": [
          {
            "id": "first-prompt",
            "label": "Review my top pages",
            "prompt": "Use PostHog to review how people use my site this week.\n\nShow my most common events and my top five pages by pageviews. Then show where visitors drop off between landing and signing up or buying. Don’t change anything.",
            "primary": true
          }
        ]
      }
    ]
  },
  {
    "slug": "use-yotpo",
    "art": {
      "scene": "app",
      "app": "yotpo"
    },
    "integration": "yotpo",
    "vertical": "ecommerce",
    "tab": "integrations",
    "order": 14,
    "kind": "explore",
    "rewardKey": "home-use-yotpo",
    "completion": "all",
    "title": "Use Yotpo in Replo",
    "description": "Read reviews and star ratings, and put your best ones on your pages.",
    "steps": [
      {
        "slug": "connect-yotpo",
        "title": "Connect Yotpo",
        "check": "connected-yotpo",
        "body": "tools",
        "tools": [
          "yotpo"
        ],
        "gatesWorkflow": true,
        "options": []
      },
      {
        "slug": "try-yotpo-prompt",
        "title": "Ask Replo about Yotpo",
        "check": null,
        "options": [
          {
            "id": "first-prompt",
            "label": "Review my product reviews",
            "prompt": "Use Yotpo to review my product reviews.\n\nShow each product’s average rating and review count, then my five most recent reviews. Pull out three quotes strong enough to put on a product page. Don’t change anything.",
            "primary": true
          }
        ]
      }
    ]
  },
  {
    "slug": "use-recharge",
    "art": {
      "scene": "app",
      "app": "recharge"
    },
    "integration": "recharge",
    "vertical": "ecommerce",
    "tab": "integrations",
    "order": 15,
    "kind": "explore",
    "rewardKey": "home-use-recharge",
    "completion": "all",
    "title": "Use Recharge in Replo",
    "description": "See active subscriptions and failed charges, and build offers that keep subscribers.",
    "steps": [
      {
        "slug": "connect-recharge",
        "title": "Connect Recharge",
        "check": "connected-recharge",
        "body": "tools",
        "tools": [
          "recharge"
        ],
        "gatesWorkflow": true,
        "options": []
      },
      {
        "slug": "try-recharge-prompt",
        "title": "Ask Replo about Recharge",
        "check": null,
        "options": [
          {
            "id": "first-prompt",
            "label": "Review my subscriptions",
            "prompt": "Use Recharge to review my subscriptions.\n\nShow how many subscriptions are active, paused and cancelled, which products have the most subscribers, and any charges that failed in the last 30 days. Don’t change anything.",
            "primary": true
          }
        ]
      }
    ]
  },
  {
    "slug": "use-triple-whale",
    "art": {
      "scene": "app",
      "app": "triple-whale"
    },
    "integration": "triple-whale",
    "vertical": "ecommerce",
    "tab": "integrations",
    "order": 16,
    "kind": "explore",
    "rewardKey": "home-use-triple-whale",
    "completion": "all",
    "title": "Use Triple Whale in Replo",
    "description": "Read blended ROAS, spend and revenue by channel, and see which pages earn it.",
    "steps": [
      {
        "slug": "connect-triple-whale",
        "title": "Connect Triple Whale",
        "check": "connected-triple-whale",
        "body": "tools",
        "tools": [
          "triple-whale"
        ],
        "gatesWorkflow": true,
        "options": []
      },
      {
        "slug": "try-triple-whale-prompt",
        "title": "Ask Replo about Triple Whale",
        "check": null,
        "options": [
          {
            "id": "first-prompt",
            "label": "Review my store’s numbers",
            "prompt": "Use Triple Whale to review my store over the last 30 days.\n\nShow revenue, ad spend, blended ROAS, MER and orders, then spend and ROAS by channel. Tell me which channel I should build my next landing page for. Don’t change anything.",
            "primary": true
          }
        ]
      }
    ]
  },
  {
    "slug": "build-sales-funnel",
    "art": {
      "scene": "outcome",
      "outcome": "sales-funnel"
    },
    "hidden": true,
    "retired": true,
    "requires": [
      "checkout/shopify"
    ],
    "vertical": "ecommerce",
    "tab": "scale",
    "order": 7,
    "kind": "explore",
    "rewardKey": "home-funnel",
    "completion": "all",
    "title": "Build a sales funnel",
    "description": "Guide shoppers from your first offer through to a completed order.",
    "steps": [
      {
        "slug": "connect-shopify",
        "title": "Connect your Shopify store",
        "check": "has-connected-shopify",
        "body": "shopify",
        "options": [
          {
            "id": "no-shopify",
            "label": "I don’t use Shopify",
            "description": "Sell with Replo products and checkout instead",
            "icon": "app:products",
            "prompt": "Help me choose what to sell.\n\nUse my existing products, or help me create one as a draft. Confirm the offer, audience, and next action before building. We can set up payments later."
          }
        ]
      },
      {
        "slug": "funnel-type",
        "title": "Choose a funnel",
        "check": "home-funnel",
        "options": [
          {
            "id": "launch",
            "label": "Product launch",
            "description": "Landing page → offer → checkout",
            "icon": "rocket",
            "primary": true,
            "templateTags": [
              "Landing"
            ],
            "prompt": "Build a product launch funnel.\n\nAsk which product it’s for, then build a landing page, an offer page with an upsell, and checkout. Link them together and show me each page before publishing."
          },
          {
            "id": "lead",
            "label": "Lead magnet",
            "description": "Free guide or sample → email → offer",
            "icon": "tag",
            "templateTags": [
              "Landing"
            ],
            "prompt": "Build a lead magnet funnel.\n\nAsk what I can give away, then build a page that collects an email in exchange for it, followed by an offer page. Show me each page before publishing."
          },
          {
            "id": "quiz",
            "label": "Quiz funnel",
            "description": "Questions → recommendation → checkout",
            "icon": "list",
            "templateTags": [
              "Landing"
            ],
            "prompt": "Build a quiz funnel.\n\nAsk what I sell, write three to five questions that lead to a product recommendation, then build the quiz page, the results page, and checkout. Show me each page before publishing."
          }
        ]
      },
      {
        "slug": "publish",
        "title": "Publish",
        "check": "has-published",
        "options": [
          {
            "id": "publish",
            "label": "Publish the page",
            "description": "Live on your Replo domain",
            "icon": "rocket",
            "primary": true,
            "prompt": "Help me publish my page.\n\nConfirm the page and domain first. Check that its purchase or booking action works before going live."
          },
          {
            "id": "domain",
            "label": "Connect my domain",
            "description": "Serve it from your own domain",
            "icon": "globe",
            "prompt": "Help me connect my domain to this page.\n\nGuide me through setup without disrupting my existing site."
          }
        ]
      }
    ]
  },
  {
    "slug": "build-storefront",
    "art": {
      "scene": "page",
      "page": "site"
    },
    "requires": [
      "checkout/replo"
    ],
    "vertical": "ecommerce",
    "tab": "launch",
    "order": 0,
    "kind": "explore",
    "rewardKey": "home-storefront",
    "completion": "all",
    "title": "Build a store from scratch",
    "description": "Pick a product and a template, and launch your own store.",
    "steps": [
      {
        "slug": "store-product",
        "title": "Pick a product",
        "check": null,
        "body": "product",
        "productSource": "replo",
        "options": []
      },
      {
        "slug": "store-build",
        "title": "Choose a site template",
        "check": null,
        "body": "template",
        "templateType": "site",
        "output": "page",
        "options": []
      },
      {
        "slug": "publish",
        "title": "Publish your store",
        "check": null,
        "body": "publish",
        "options": []
      }
    ]
  },
  {
    "slug": "find-product-to-sell",
    "art": {
      "scene": "board",
      "items": "product-ideas"
    },
    "hidden": true,
    "vertical": "ecommerce",
    "tab": "launch",
    "order": 3,
    "kind": "explore",
    "rewardKey": "home-idea",
    "completion": "all",
    "title": "Validate a product idea",
    "description": "Test customer demand before investing in your next product idea.",
    "steps": [
      {
        "slug": "idea-about",
        "title": "Define your customer and offer",
        "check": null,
        "options": [
          {
            "id": "about",
            "label": "Describe my product idea",
            "description": "Customer need, product idea, and constraints",
            "icon": "lightbulb",
            "primary": true,
            "prompt": "Help me validate a product idea. Ask what I want to sell, who it serves, and my constraints. If I have no idea yet, ask about my experience and suggest a few options. Identify assumptions to test before building."
          }
        ]
      },
      {
        "slug": "idea-pick",
        "title": "Pick an idea",
        "check": null,
        "options": [
          {
            "id": "compare",
            "label": "Compare the ideas",
            "description": "Demand, competition, and what it takes to start",
            "icon": "list",
            "primary": true,
            "prompt": "Compare the product ideas we discussed.\n\nFor each, compare the customer need, competing offers, likely costs, and what it takes to test demand. Cite evidence where available, label assumptions, and propose a small validation test. Do not invent market size or sales data."
          }
        ]
      },
      {
        "slug": "idea-save",
        "title": "Save it as a product",
        "check": "home-product",
        "options": [
          {
            "id": "save",
            "label": "Save as a draft product",
            "description": "Name, description, and a starting price",
            "icon": "app:products",
            "primary": true,
            "prompt": "Save the product idea we chose as a draft product.\n\nGive it a name, a short description, and a starting price I can change later."
          }
        ]
      }
    ]
  },
  {
    "slug": "import-shopify-products",
    "art": {
      "scene": "page",
      "page": "catalog"
    },
    "hidden": true,
    "retired": true,
    "requires": [
      "checkout/shopify"
    ],
    "vertical": "ecommerce",
    "tab": "launch",
    "order": 2,
    "kind": "explore",
    "rewardKey": "home-products",
    "completion": "all",
    "title": "Import your products from Shopify",
    "description": "Use real products, variants, and prices across your campaign pages.",
    "steps": [
      {
        "slug": "import-connect",
        "title": "Connect your Shopify store",
        "description": "Your products, prices, and photos come through as soon as the store is connected.",
        "check": "has-connected-shopify",
        "body": "shopify",
        "options": []
      }
    ]
  },
  {
    "slug": "publish-page",
    "art": {
      "scene": "outcome",
      "outcome": "publish"
    },
    "hidden": true,
    "retired": true,
    "tab": "launch",
    "order": 0,
    "kind": "explore",
    "rewardKey": "home-launch",
    "completion": "all",
    "title": "Launch a campaign page",
    "description": "Check your offer and purchase flow, then take your campaign live.",
    "steps": [
      {
        "slug": "publish-pick",
        "title": "Pick the page",
        "description": "Choose the page and campaign offer you want to launch.",
        "check": null,
        "options": [
          {
            "id": "latest",
            "label": "The page we just built",
            "description": "Replo picks the newest draft",
            "icon": "app:siteBuilder",
            "primary": true,
            "prompt": "Prepare the campaign page we most recently built for launch. Confirm the exact page, audience, offer, and destination domain. Check mobile layout, prices, links, and purchase or booking flow. Report blockers and show me the launch plan before publishing."
          },
          {
            "id": "choose",
            "label": "Choose a page",
            "description": "See every draft and pick one",
            "icon": "layers",
            "prompt": "List my pages and let me choose one for a campaign launch. Confirm its offer and destination domain, review mobile layout and purchase flow, and report blockers before publishing."
          }
        ]
      },
      {
        "slug": "publish-live",
        "title": "Go live",
        "check": "has-published",
        "options": [
          {
            "id": "publish",
            "label": "Publish",
            "description": "On your Replo domain",
            "icon": "rocket",
            "primary": true,
            "prompt": "Help me publish my page.\n\nConfirm the page and domain first. Check that its purchase or booking action works before going live."
          }
        ]
      },
      {
        "slug": "publish-domain",
        "title": "Use your own domain",
        "optional": true,
        "check": "custom-domain",
        "options": [
          {
            "id": "domain",
            "label": "Connect my domain",
            "description": "Choose an address and verify its DNS configuration",
            "icon": "globe",
            "primary": true,
            "prompt": "Help me connect my domain to this page.\n\nGuide me through setup without disrupting my existing site."
          }
        ]
      }
    ]
  },
  {
    "slug": "connect-domain",
    "art": {
      "scene": "outcome",
      "outcome": "domain"
    },
    "hidden": true,
    "tab": "launch",
    "order": 1,
    "kind": "explore",
    "rewardKey": "home-domain",
    "completion": "all",
    "title": "Connect your domain",
    "description": "Keep your brand in the URL from the ad click to your campaign page.",
    "steps": [
      {
        "slug": "domain-choose",
        "title": "Choose the address",
        "description": "Choose an unused subdomain and check existing DNS before changing it.",
        "check": null,
        "options": [
          {
            "id": "subdomain",
            "label": "A subdomain",
            "description": "shop.yourbrand.com, the safest option",
            "icon": "globe",
            "primary": true,
            "prompt": "Help me connect a subdomain to Replo, like shop.mybrand.com.\n\nAsk for the domain, then give me the exact DNS record to add. My existing site must keep working."
          },
          {
            "id": "path",
            "label": "A path on your site",
            "description": "yourbrand.com/pages/…, keeps one domain",
            "icon": "link",
            "prompt": "Help me serve Replo pages under a path on my existing domain.\n\nExplain what that needs from my current host and whether a subdomain would be simpler."
          }
        ]
      },
      {
        "slug": "domain-dns",
        "title": "Verify your domain routing",
        "check": "custom-domain",
        "options": [
          {
            "id": "dns",
            "label": "Check my domain setup",
            "description": "Verify the DNS or routing configuration",
            "icon": "list",
            "primary": true,
            "prompt": "Check the setup for the address and hosting method we chose. For a subdomain, show the exact DNS record and verify propagation. For a path on an existing site, explain and verify the required host routing. Identify blockers without disrupting the existing site."
          }
        ]
      },
      {
        "slug": "domain-page",
        "title": "Point a page at it",
        "optional": true,
        "check": "has-published",
        "options": [
          {
            "id": "point",
            "label": "Put a page on the domain",
            "description": "Publish or move a page to the new address",
            "icon": "rocket",
            "primary": true,
            "prompt": "Publish a page on the domain we connected.\n\nAsk which page, then put it live there and check that it loads."
          }
        ]
      }
    ]
  }
];
